import React, { useState } from "react";
import { Modal, Container, Row, Col } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import { useDispatch } from "react-redux";
import {
  selectedTooth,
  setHistoryModal,
} from "../config/preauthorizationSlice";
import { FaTooth } from "react-icons/fa";
import { claimSelectedTooth } from "features/cliams/config/claimSlice";
const TeethModalSelect = ({ modal, setModal, setSelectedTooth }) => {
  const dispatch = useDispatch();
  const handleToothClick = (toothData) => {
    const toothInfo = getToothInfo(toothData.code);
    // setSelectedTooth(toothInfo);
    dispatch(selectedTooth(toothInfo));
    dispatch(claimSelectedTooth(toothInfo));
    dispatch;
    setModal(false);
    dispatch(setHistoryModal(true));
  };

  const getToothInfo = (toothNumber) => {
    if (toothNumber >= 11 && toothNumber <= 18) {
      return {
        type: "right",
        position: "upper",
        number: toothNumber,
        dentition: "Permanent",
      };
    }

    if (toothNumber >= 21 && toothNumber <= 28) {
      return {
        type: "left",
        position: "upper",
        number: toothNumber,
        dentition: "Permanent",
      };
    }

    if (toothNumber >= 31 && toothNumber <= 38) {
      return {
        type: "left",
        position: "lower",
        number: toothNumber,
        dentition: "Permanent",
      };
    }

    if (toothNumber >= 41 && toothNumber <= 48) {
      return {
        type: "right",
        position: "lower",
        number: toothNumber,
        dentition: "Permanent",
      };
    }

    if (toothNumber >= 51 && toothNumber <= 55) {
      return {
        type: "right",
        position: "upper",
        number: toothNumber,
        dentition: "Deciduous",
      };
    }

    if (toothNumber >= 61 && toothNumber <= 65) {
      return {
        type: "left",
        position: "upper",
        number: toothNumber,
        dentition: "Deciduous",
      };
    }

    if (toothNumber >= 71 && toothNumber <= 75) {
      return {
        type: "left",
        position: "lower",
        number: toothNumber,
        dentition: "Deciduous",
      };
    }

    if (toothNumber >= 81 && toothNumber <= 85) {
      return {
        type: "right",
        position: "lower",
        number: toothNumber,
        dentition: "Deciduous",
      };
    }

    // Fallback if the code doesn't match known ranges
    return {
      type: "unknown",
      position: "unknown",
      number: toothNumber,
      dentition: "Unknown",
    };
  };

  return (
    <Modal show={modal} centered dialogClassName="tooth-modal">
      <Modal.Header className="d-flex justify-content-between align-items-center ps-4 pe-4 pt-3">
        <Modal.Title as="h5" className="text-600 fs-11">
          <FaTooth className="me-2" />
          Select Tooth
        </Modal.Title>
        <FalconCloseButton
          size="sm"
          onClick={() => {
            setModal(false);
          }}
          className="position-relative"
        />
      </Modal.Header>
      <Modal.Body>
        <Container fluid>
          <Row className="justify-content-center">
            <Col xs={12}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="400px"
                viewBox="0 0 714.269 899.902"
                // {...props}
              >
                <g
                  id="Group_8589"
                  data-name="Group 8589"
                  transform="translate(-551.373 -159.375)"
                >
                  <g
                    id="Group_8587"
                    data-name="Group 8587"
                    transform="translate(124.001 -8.133)"
                  >
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 43 })}
                      code={43}
                    >
                      <g
                        id="Group_8451"
                        data-name="Group 8451"
                        transform="translate(673.972 848.147)"
                        onClick={() => handleToothClick({ code: 43 })}
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee3"
                          id="Path_22946"
                          data-name="Path 22946"
                          d="M803.166,1437.419c-6.67-4.262-24.748,2.885-29.4,9.956s26.422,30.422,31.538,22.886S812.191,1443.189,803.166,1437.419Z"
                          transform="translate(-773.293 -1436.137)"
                          fill="#94e7cb"
                        />
                      </g>
                    </a>

                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 42 })}
                      code={42}
                    >
                      <g
                        id="Group_8452"
                        data-name="Group 8452"
                        transform="translate(709.5 866.432)"
                        onClick={() => handleToothClick({ code: 42 })}
                      >
                        <path
                          id="Path_22947"
                          className="stylehovee4"
                          data-name="Path 22947"
                          d="M865.693,1471.738c-12.576-4.375-24.258,19.642-24.258,19.642s30.754,14.65,31.723,10.442S878.272,1476.114,865.693,1471.738Z"
                          transform="translate(-841.435 -1471.206)"
                          fill="#8ae6ab"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 41 })}
                      code={41}
                    >
                      <g
                        id="Group_8453"
                        data-name="Group 8453"
                        transform="translate(745.323 874.209)"
                      >
                        <path
                          id="Path_22948"
                          className="stylehovee4"
                          data-name="Path 22948"
                          d="M926.645,1486.125c-11.783-.264-16.217,20.553-16.5,24.435s31.6,9.956,31.576,2.988S938.431,1486.39,926.645,1486.125Z"
                          transform="translate(-910.142 -1486.122)"
                          fill="#8ae6ab"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 11 })}
                      code={11}
                    >
                      <g
                        id="Group_8454"
                        data-name="Group 8454"
                        transform="translate(725.928 208.853)"
                      >
                        <path
                          id="Path_22949"
                          className="stylehovee4"
                          data-name="Path 22949"
                          d="M873.015,222.6c2.33,11.657,15.518,28.584,30.3,26.363,15.206-2.285,22.055-23.992,22.544-33.909S870.681,210.947,873.015,222.6Z"
                          transform="translate(-872.943 -210)"
                          fill="#8ae6ab"
                        />
                      </g>
                    </a>

                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 12 })}
                      code={12}
                    >
                      <g
                        id="Group_8455"
                        data-name="Group 8455"
                        transform="translate(687.38 221.732)"
                      >
                        <path
                          className="stylehovee3"
                          id="Path_22950"
                          data-name="Path 22950"
                          d="M799.612,252.087c5.755,6.985,18.979,24.694,31.269,18.054,7.753-4.187,5.321-28.309,2.819-34.123S793.858,245.1,799.612,252.087Z"
                          transform="translate(-799.011 -234.701)"
                          fill="#8ae6ab"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 13 })}
                      code={13}
                    >
                      <g
                        id="Group_8456"
                        className="stylehovee3"
                        data-name="Group 8456"
                        transform="translate(655.283 241.477)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_22951"
                          data-name="Path 22951"
                          d="M738.016,297.576c5.194,5.947,23.788,17.368,33.136,8.307,9.041-8.768,0-26.9-3.115-32.473S732.826,291.629,738.016,297.576Z"
                          transform="translate(-737.449 -272.571)"
                          fill="#94e7cb"
                        />
                      </g>
                    </a>
                    <g
                      id="Group_8457"
                      data-name="Group 8457"
                      transform="translate(725.722 207.603)"
                      onClick={() => handleToothClick({ code: 13 })}
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_22952"
                        data-name="Path 22952"
                        d="M897.767,208.211c-14.939,1.192-26.156,6.976-25.157,12.275,1.295,6.875,20.494,3.164,27.3,2.361s25.932-1.495,25.582-9.269C925.171,206.429,909.325,207.288,897.767,208.211Z"
                        transform="translate(-872.548 -207.603)"
                        fill="#67c78a"
                      />
                    </g>
                    <g
                      id="Group_8458"
                      data-name="Group 8458"
                      transform="translate(687.302 220.407)"
                      onClick={() => handleToothClick({ code: 13 })}
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_22953"
                        data-name="Path 22953"
                        d="M812.989,236.713c-8.189,3.478-16.477,10.756-13.516,14.321s13.231-2.4,18.909-4.859c6.655-2.885,17.043-6.193,15.148-11.6C831.807,229.648,821.177,233.235,812.989,236.713Z"
                        transform="translate(-798.859 -232.16)"
                        fill="#67c78a"
                      />
                    </g>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 51 })}
                      code={51}
                    >
                      <g
                        id="Group_8459"
                        data-name="Group 8459"
                        transform="translate(730.151 330.995)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee4"
                          id="Path_22954"
                          data-name="Path 22954"
                          d="M881.106,524.359c2.1,11.276,14.132,27.62,27.677,25.427,13.938-2.257,20.277-23.287,20.755-32.887S879,513.083,881.106,524.359Z"
                          transform="translate(-881.043 -512.048)"
                          fill="#8ae6ab"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 52 })}
                      code={52}
                    >
                      <g
                        id="Group_8460"
                        data-name="Group 8460"
                        transform="translate(696.968 343.193)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee4"
                          id="Path_22955"
                          data-name="Path 22955"
                          d="M818.373,558.585c6.919,5.374,23.172,19.289,33.368,10.406,6.432-5.6-.992-27.867-4.589-32.826S811.454,553.211,818.373,558.585Z"
                          transform="translate(-817.399 -535.443)"
                          fill="#8ae6ab"
                        />
                      </g>
                    </a>
                    <g
                      id="Group_8461"
                      data-name="Group 8461"
                      transform="translate(729.965 329.785)"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_22956"
                        data-name="Path 22956"
                        d="M903.825,510.352c-13.69,1.2-23.984,6.83-23.084,11.955,1.165,6.65,18.766,3,25,2.2s23.762-1.524,23.465-9.047C928.937,508.546,914.417,509.424,903.825,510.352Z"
                        transform="translate(-880.686 -509.728)"
                        fill="#67c78a"
                      />
                    </g>
                    <g
                      id="Group_8462"
                      data-name="Group 8462"
                      transform="translate(696.888 342.202)"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_22957"
                        data-name="Path 22957"
                        d="M827.991,541.446c-6.994,5.025-13.275,13.661-9.721,16.4s11.987-5.075,16.825-8.607c5.672-4.139,14.78-9.471,11.841-14.177C844.262,530.774,834.986,536.422,827.991,541.446Z"
                        transform="translate(-817.245 -533.543)"
                        fill="#67c78a"
                      />
                    </g>
                    <g
                      id="Group_8463"
                      data-name="Group 8463"
                      transform="translate(654.261 239.552)"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_22958"
                        data-name="Path 22958"
                        d="M745.2,275.7c-10.7,8.351-11.33,18.125-7.74,20.579,3.752,2.567,7.549-1.115,11.327-2.077,5.193-1.322,9.535-.472,11.99-2.832s1.9-5.414,3.019-8.779c1.132-3.4,5.569-6.986,3.306-10.951C764.766,267.56,755.957,267.3,745.2,275.7Z"
                        transform="translate(-735.489 -268.88)"
                        fill="#46bc94"
                      />
                    </g>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 53 })}
                      code={53}
                    >
                      <g
                        id="Group_8464"
                        className="stylehovee3"
                        data-name="Group 8464"
                        transform="translate(674.41 369.635)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_22959"
                          data-name="Path 22959"
                          d="M775.223,617.154c6.377,4.213,26.671,10.084,33.06-.779,6.179-10.51-7.248-25.394-11.592-29.789S768.849,612.941,775.223,617.154Z"
                          transform="translate(-774.134 -586.157)"
                          fill="#94e7cb"
                        />
                      </g>
                      <g
                        id="Group_8465"
                        className="stylehovee3"
                        data-name="Group 8465"
                        transform="translate(672.506 368.959)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_22960"
                          data-name="Path 22960"
                          d="M795.268,586.254c-3.229-3.21-11.515-1.184-19.393,9.427-7.834,10.548-5.906,19.831-1.924,21.2,4.162,1.43,6.758-2.984,10.035-4.854,4.505-2.571,8.777-2.9,10.459-5.73s.376-5.541.557-8.97C795.183,593.861,798.4,589.371,795.268,586.254Z"
                          transform="translate(-770.482 -584.863)"
                          fill="#46bc94"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 14 })}
                      code={14}
                    >
                      <g
                        id="Group_8466"
                        className="stylehovee2"
                        data-name="Group 8466"
                        transform="translate(629.393 270.31)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_22961"
                          data-name="Path 22961"
                          d="M719.259,335.434c-3.306-2.243-6.494-7.792-15.822-7.555s-19.832,26.208-13.932,32.23,11.926,3.9,15,5.078,3.233,5.505,12.867,7.32c10.036,1.887,23.967-21.962,16.293-31.4C729.8,336.348,721.452,336.923,719.259,335.434Z"
                          transform="translate(-687.793 -327.871)"
                          fill="#ffe394"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 15 })}
                      code={15}
                    >
                      <g
                        id="Group_8467"
                        className="stylehovee2"
                        data-name="Group 8467"
                        transform="translate(608.999 311.468)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_22962"
                          data-name="Path 22962"
                          d="M679.724,413.275c-4.524-1.508-5.177-7.061-13.823-6.411-11.691.88-19.807,27.869-16.466,33.056,4.775,7.415,14.33,4.4,17.218,5.655s5.656,6.915,14.454,6.663c10.447-.3,18.853-27.776,13.2-33.684C688.835,412.841,682.855,414.317,679.724,413.275Z"
                          transform="translate(-648.678 -406.811)"
                          fill="#ffe394"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 16 })}
                      code={16}
                    >
                      <g
                        id="Group_8468"
                        data-name="Group 8468"
                        transform="translate(581.453 352.21)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_22963"
                          className="stylehovee"
                          data-name="Path 22963"
                          d="M637.641,489.266c-7.935-2.706-20.96-6.519-26.871-2.706-5.592,3.605-4.151,17.856-6.494,22.723s-11.183,14.534-7.575,23.447c5.77,14.247,40.4,21.1,50.137,15.87,7.935-4.259,6.854-17.674,8.116-23.084s10.641-13.348,7.935-20.922S645.576,491.97,637.641,489.266Z"
                          transform="translate(-595.847 -484.952)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 17 })}
                      code={17}
                    >
                      <g
                        id="Group_8469"
                        data-name="Group 8469"
                        transform="translate(567.58 416.473)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee"
                          id="Path_22964"
                          data-name="Path 22964"
                          d="M607.774,612.52c-6.494-.9-16.594-7.214-24.71-2.706s-6.855,16.953-8.3,23.629-7.887,18.413-4.616,24.729c5.232,10.1,14.885,7.074,26.98,9.9,10.632,2.48,20.788,2.28,25.43-1.262,9.917-7.574,13-39.186,7.412-46.76C626.139,614.85,614.265,613.422,607.774,612.52Z"
                          transform="translate(-569.238 -608.206)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 54 })}
                      code={54}
                    >
                      <g
                        id="Group_8470"
                        data-name="Group 8470"
                        transform="translate(651.747 405.174)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_22965"
                          className="stylehovee"
                          data-name="Path 22965"
                          d="M764.38,657.817c-6.407-2.193-16.926-5.283-21.7-2.193-4.516,2.922-3.352,14.469-5.244,18.414s-8.923,12.424-6.117,19c3.466,8.123,13.856,8,19.082,9.557,5.951,1.768,13.1,6.145,20.836,2.211s6.1-13.23,7.124-17.614,6.918-10.864,4.732-17S770.788,660.008,764.38,657.817Z"
                          transform="translate(-730.667 -654.321)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 55 })}
                      code={55}
                    >
                      <g
                        id="Group_8471"
                        data-name="Group 8471"
                        transform="translate(643.103 456.548)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee"
                          id="Path_22966"
                          data-name="Path 22966"
                          d="M744.464,755.731c-5.885-.442-15.316-5.538-22.351-1.027s-5.194,15.619-6.109,21.7-3.62,15.478-.322,20.965c5.274,8.775,14.039,5.678,25.065,7.527,9.692,1.624,16.259.8,20.228-2.643,8.478-7.368,9.183-35.844,3.729-42.331C760.963,755.471,750.346,756.173,744.464,755.731Z"
                          transform="translate(-714.089 -752.853)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 18 })}
                      code={18}
                    >
                      <g
                        id="Group_8472"
                        data-name="Group 8472"
                        transform="translate(565.773 480.236)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee"
                          id="Path_22967"
                          data-name="Path 22967"
                          d="M572.932,733.866c-6.433,6.43-3.769,19.3-4.227,24.251-.737,7.9-6.43,15.617.367,23.7s33.559,10.061,43.732,1.1c12.308-10.839,13.963-33.072,3.306-44.832C609.67,730.984,579.362,727.432,572.932,733.866Z"
                          transform="translate(-565.773 -730.499)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 48 })}
                      code={48}
                    >
                      <g
                        id="Group_8473"
                        data-name="Group 8473"
                        transform="translate(568.491 592.323)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee"
                          id="Path_22968"
                          data-name="Path 22968"
                          d="M617.848,948.034c-6.687-5.356-13.607-.665-20.9-.469s-18.576-3.366-23.494,4.9c-5.852,9.833.526,17.157.643,23.228s-4.744,16.461,2.141,22.252,15.957,1.975,22.221,1.484,17.747,1.722,23.288-6.147,1.044-15.164-.193-21.812S624.535,953.39,617.848,948.034Z"
                          transform="translate(-570.986 -945.477)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 47 })}
                      code={47}
                    >
                      <g
                        id="Group_8474"
                        data-name="Group 8474"
                        transform="translate(571.878 649.708)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee"
                          id="Path_22969"
                          data-name="Path 22969"
                          d="M625.973,1057.661c-13.475-7.125-44.009,5.339-47.137,13.21-4.013,10.1,1.942,16.836,4.4,24.085s.3,19.552,9.713,23.96c14.375,6.733,44.676-5.831,48.562-15.93,3.328-8.652-2.2-16.7-4.272-22.921S637.242,1063.619,625.973,1057.661Z"
                          transform="translate(-577.483 -1055.54)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 46 })}
                      code={46}
                    >
                      <g
                        id="Group_8475"
                        data-name="Group 8475"
                        transform="translate(589.583 711.248)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee"
                          id="Path_22970"
                          data-name="Path 22970"
                          d="M658.174,1173.874c-7.615-1.792-16.347,4.811-24.027,7.349s-20.6,6.506-22.347,14.875c-2.3,11.027,7.08,17.451,9.675,23.205s1.527,17.435,11,20.795c9.321,3.309,18.445-2.971,25.105-6.133s18.913-6.857,20.813-15.806-5.407-16.29-8.272-22.379S665.79,1175.663,658.174,1173.874Z"
                          transform="translate(-611.439 -1173.57)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 85 })}
                      code={85}
                    >
                      <g
                        id="Group_8476"
                        data-name="Group 8476"
                        transform="translate(649.149 631.326)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee"
                          id="Path_22971"
                          data-name="Path 22971"
                          d="M771.585,942.33c-10.85-8.252-39.607-1.707-43.514,4.781-5.014,8.326-.742,15.136.372,21.892s-2.584,17.293,5.076,22.556c11.7,8.036,40.266,1.371,45.167-6.973,4.2-7.148.493-15.059-.426-20.846S780.658,949.23,771.585,942.33Z"
                          transform="translate(-725.685 -938.46)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 84 })}
                      code={84}
                    >
                      <g
                        id="Group_8477"
                        data-name="Group 8477"
                        transform="translate(658.358 687.195)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee"
                          id="Path_22972"
                          data-name="Path 22972"
                          d="M784.913,1046.377c-5.955-2.466-13.931,1.746-20.511,2.793s-17.614,2.562-20.142,9.135c-3.333,8.662,3.446,15.129,4.794,20.151s-1.068,14.38,6.191,18.367c7.141,3.925,15.393.027,21.227-1.662s16.288-3.071,19.019-10.1-2.239-13.963-3.762-19.294S790.869,1048.84,784.913,1046.377Z"
                          transform="translate(-743.348 -1045.614)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 45 })}
                      code={45}
                    >
                      <g
                        id="Group_8478"
                        data-name="Group 8478"
                        transform="translate(620.917 775.132)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee2"
                          id="Path_22973"
                          data-name="Path 22973"
                          d="M702.648,1296.151c-5.767-.606-10.485,4.058-14.234,5.369s-11.7.172-15.921,8.094,6.377,30.614,15.991,31.376c7.23.57,9.178-3.74,13.625-6.14s11.84-3.28,13.328-10.539C717.386,1314.823,707.366,1296.645,702.648,1296.151Z"
                          transform="translate(-671.537 -1296.097)"
                          fill="#ffe394"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 44 })}
                      code={44}
                    >
                      <g
                        id="Group_8479"
                        data-name="Group 8479"
                        transform="translate(645.654 813.489)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee2"
                          id="Path_22974"
                          data-name="Path 22974"
                          d="M745.209,1369.96c-6.069-1.265-7.982,1.693-14.173,5.487-5.793,3.548-10.517,4.039-11.831,10.039-1.836,8.393,7.944,25.048,16.7,27.26,6.376,1.61,10.24-3.612,15.959-7.45,5.483-3.679,7.992-5.464,9.114-11.027C762.392,1387.274,752.4,1371.462,745.209,1369.96Z"
                          transform="translate(-718.981 -1369.664)"
                          fill="#ffe394"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      code={43}
                    >
                      <g
                        id="Group_8480"
                        data-name="Group 8480"
                        transform="translate(672.796 859.402)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee3"
                          id="Path_22975"
                          data-name="Path 22975"
                          d="M797.528,1472.779c-2.42-2.793-1.351-7.062-4.839-9.676-2.6-1.954-6.14-1.954-10.141-2.419s-7.393-5.573-10.7-1.212c-2.328,3.074.185,12.56,9.767,19.073s19.262,7.909,22.332,2.512C806.282,1476.951,799.947,1475.568,797.528,1472.779Z"
                          transform="translate(-771.039 -1457.722)"
                          fill="#46bc94"
                        />
                      </g>
                    </a>
                    <g
                      id="Group_8481"
                      data-name="Group 8481"
                      transform="translate(708.743 885.269)"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_22976"
                        data-name="Path 22976"
                        d="M857.953,1511.721c-3.915-1.54-15.116-7.077-17.459-2.792s3.546,7.012,14.222,10.222c11.277,3.391,16.271,4.178,17.635-.491S861.865,1513.263,857.953,1511.721Z"
                        transform="translate(-839.983 -1507.335)"
                        fill="#67c78a"
                      />
                    </g>
                    <g
                      id="Group_8482"
                      data-name="Group 8482"
                      transform="translate(745.017 896.477)"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_22977"
                        data-name="Path 22977"
                        d="M925.987,1529.385c-7.431-.45-16.073-1.613-16.4,1.846-.676,7.157,9.94,6.293,16.938,6.87s15.149,1.517,14.887-4.709C941.222,1528.849,933.421,1529.831,925.987,1529.385Z"
                        transform="translate(-909.554 -1528.83)"
                        fill="#67c78a"
                      />
                    </g>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 83 })}
                      code={83}
                    >
                      <g
                        id="Group_8483"
                        data-name="Group 8483"
                        transform="translate(683.192 739.047)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee3"
                          id="Path_22978"
                          data-name="Path 22978"
                          d="M791.823,1152.114c-5.863,6.106,20.447,34.721,26.849,28.241s11.7-25.368,3.87-32.683C816.759,1142.267,797.682,1146.007,791.823,1152.114Z"
                          transform="translate(-790.977 -1145.064)"
                          fill="#94e7cb"
                        />
                        <path
                          className="stylehovee3"
                          id="Path_22978"
                          data-name="Path 22978"
                          d="M791.823,1152.114c-5.863,6.106,20.447,34.721,26.849,28.241s11.7-25.368,3.87-32.683C816.759,1142.267,797.682,1146.007,791.823,1152.114Z"
                          transform="translate(-790.977 -1145.064)"
                          fill="#94e7cb"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 82 })}
                      code={82}
                    >
                      <g
                        id="Group_8484"
                        data-name="Group 8484"
                        transform="translate(713.193 764.406)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_22979"
                          className="stylehovee4"
                          data-name="Path 22979"
                          d="M877.25,1195.464c-10.882-7.673-28.733,12.192-28.733,12.192s25.523,22.562,27.614,18.785S888.135,1203.138,877.25,1195.464Z"
                          transform="translate(-848.517 -1193.702)"
                          fill="#8ae6ab"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 81 })}
                      code={81}
                    >
                      <g
                        id="Group_8485"
                        data-name="Group 8485"
                        transform="translate(747.222 775.382)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_22980"
                          className="stylehovee4"
                          data-name="Path 22980"
                          d="M932.019,1214.8c-11.733-1.117-17.663,19.325-18.227,23.177s30.795,12.218,31.277,5.265S943.755,1215.915,932.019,1214.8Z"
                          transform="translate(-913.785 -1214.753)"
                          fill="#8ae6ab"
                        />
                      </g>
                    </a>
                    <g
                      id="Group_8486"
                      data-name="Group 8486"
                      transform="translate(681.386 746.447)"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_22981"
                        data-name="Path 22981"
                        d="M811.85,1178.246c-1.872-3.186-.045-7.189-3-10.394-2.205-2.4-5.682-3.039-9.531-4.224s-6.256-6.824-10.3-3.138c-2.847,2.6-2.1,12.385,6.136,20.532s17.5,11.281,21.5,6.532C819.7,1183.942,813.721,1181.429,811.85,1178.246Z"
                        transform="translate(-787.513 -1159.257)"
                        fill="#46bc94"
                      />
                    </g>
                    <g
                      id="Group_8487"
                      data-name="Group 8487"
                      transform="translate(711.788 777.712)"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_22982"
                        data-name="Path 22982"
                        d="M862.933,1227.547c-3.34-2.559-12.579-10.97-16.013-7.5s1.476,7.718,10.853,13.747c9.9,6.369,14.488,8.5,17.088,4.391S866.268,1230.109,862.933,1227.547Z"
                        transform="translate(-845.823 -1219.222)"
                        fill="#67c78a"
                      />
                    </g>
                    <g
                      id="Group_8488"
                      data-name="Group 8488"
                      transform="translate(745.791 799.335)"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_22983"
                        data-name="Path 22983"
                        d="M929.644,1257.2c-7.379-.986-15.914-2.773-16.493.653-1.192,7.089,9.458,7,16.4,8.078s15,2.61,15.189-3.619C944.878,1257.764,937.026,1258.178,929.644,1257.2Z"
                        transform="translate(-913.059 -1255.841)"
                        fill="#67c78a"
                      />
                    </g>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 61 })}
                      code={61}
                    >
                      <g
                        id="Group_8489"
                        data-name="Group 8489"
                        transform="translate(781.017 331.6)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_22984"
                          className="stylehovee4"
                          data-name="Path 22984"
                          d="M978.6,518.061c.477,9.6,6.83,30.63,20.8,32.884,13.58,2.191,25.645-14.154,27.752-25.431S978.127,508.462,978.6,518.061Z"
                          transform="translate(-978.602 -513.209)"
                          fill="#8ae6ab"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 62 })}
                      code={62}
                    >
                      <g
                        id="Group_8490"
                        data-name="Group 8490"
                        transform="translate(824.74 343.193)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_22985"
                          className="stylehovee4"
                          data-name="Path 22985"
                          d="M1069.581,536.165c-3.6,4.958-11.021,27.223-4.589,32.826,10.2,8.883,26.449-5.032,33.368-10.406S1073.182,531.207,1069.581,536.165Z"
                          transform="translate(-1062.459 -535.443)"
                          fill="#8ae6ab"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      code={63}
                    >
                      <g
                        id="Group_8491"
                        data-name="Group 8491"
                        transform="translate(848.424 369.635)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee3"
                          id="Path_22986"
                          data-name="Path 22986"
                          d="M1121.074,586.586c-4.343,4.395-17.771,19.279-11.592,29.789,6.389,10.863,26.683,4.993,33.06.779S1125.415,582.191,1121.074,586.586Z"
                          transform="translate(-1107.884 -586.157)"
                          fill="#94e7cb"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 64 })}
                      code={64}
                    >
                      <g
                        id="Group_8492"
                        data-name="Group 8492"
                        transform="translate(853.926 405.174)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_22987"
                          className="stylehovee"
                          data-name="Path 22987"
                          d="M1159.332,655.624c-4.773-3.089-15.292,0-21.7,2.193s-16.531,6.235-18.714,12.373,3.713,12.618,4.733,17-.613,13.68,7.123,17.614,14.885-.443,20.837-2.211c5.225-1.552,15.616-1.433,19.082-9.557,2.806-6.577-4.225-15.053-6.117-19S1163.847,658.546,1159.332,655.624Z"
                          transform="translate(-1118.437 -654.321)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 65 })}
                      code={65}
                    >
                      <g
                        id="Group_8493"
                        data-name="Group 8493"
                        transform="translate(861.371 456.548)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee"
                          id="Path_22988"
                          data-name="Path 22988"
                          d="M1178.8,754.7c-7.035-4.511-16.466.585-22.351,1.027s-16.5-.26-20.24,4.19c-5.454,6.487-4.749,34.963,3.729,42.331,3.969,3.446,10.536,4.267,20.228,2.643,11.026-1.849,19.791,1.248,25.066-7.527,3.3-5.487.6-14.889-.323-20.965S1185.836,759.218,1178.8,754.7Z"
                          transform="translate(-1132.716 -752.853)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 21 })}
                      code={21}
                    >
                      <g
                        id="Group_8494"
                        data-name="Group 8494"
                        transform="translate(780.876 208.843)"
                      >
                        <path
                          id="Path_22989"
                          className="stylehovee4"
                          data-name="Path 22989"
                          d="M978.334,215.071c.521,9.915,7.27,31.667,22.484,33.9,14.785,2.173,27.918-14.8,30.209-26.46S977.813,205.155,978.334,215.071Z"
                          transform="translate(-978.33 -209.98)"
                          fill="#8ae6ab"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 22 })}
                      code={22}
                    >
                      <g
                        id="Group_8495"
                        data-name="Group 8495"
                        transform="translate(835.625 221.915)"
                      >
                        <path
                          className="stylehovee4"
                          id="Path_22990"
                          data-name="Path 22990"
                          d="M1085.53,236.422c-2.417,5.848-4.5,30,3.317,34.077,12.385,6.46,25.35-11.441,31-18.509S1087.949,230.573,1085.53,236.422Z"
                          transform="translate(-1083.338 -235.053)"
                          fill="#8ae6ab"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 23 })}
                      code={23}
                    >
                      <g
                        id="Group_8496"
                        data-name="Group 8496"
                        transform="translate(870.992 241.294)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_22991"
                          className="stylehovee3"
                          data-name="Path 22991"
                          d="M1157.983,273.053c-3.118,5.569-11.875,23.894-2.834,32.662,9.347,9.062,27.942-2.36,33.135-8.307S1161.1,267.483,1157.983,273.053Z"
                          transform="translate(-1151.169 -272.22)"
                          fill="#94e7cb"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink cursor-pointer"
                      onClick={() => handleToothClick({ code: 24 })}
                      code={24}
                    >
                      <g
                        id="Group_8497"
                        data-name="Group 8497"
                        transform="translate(882.66 270.31)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee2"
                          id="Path_22992"
                          data-name="Path 22992"
                          d="M1205.988,327.878c-9.328-.236-12.516,5.312-15.822,7.555-2.193,1.49-10.542.915-14.4,5.668-7.674,9.442,6.258,33.292,16.293,31.4,9.634-1.814,9.8-6.14,12.866-7.32s9.092.944,15-5.078S1215.312,328.114,1205.988,327.878Z"
                          transform="translate(-1173.547 -327.871)"
                          fill="#ffe394"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 25 })}
                      code={25}
                    >
                      <g
                        id="Group_8498"
                        data-name="Group 8498"
                        transform="translate(903.692 311.468)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee2"
                          id="Path_22993"
                          data-name="Path 22993"
                          d="M1244.109,406.864c-8.646-.65-9.3,4.9-13.823,6.411-3.13,1.042-9.111-.433-14.582,5.279-5.656,5.907,2.751,33.384,13.2,33.684,8.8.252,11.562-5.407,14.454-6.663s12.442,1.76,17.218-5.655C1263.916,434.732,1255.8,407.744,1244.109,406.864Z"
                          transform="translate(-1213.885 -406.811)"
                          fill="#ffe394"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 26 })}
                      code={26}
                    >
                      <g
                        id="Group_8499"
                        data-name="Group 8499"
                        transform="translate(911.153 352.21)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee"
                          id="Path_22994"
                          data-name="Path 22994"
                          d="M1280.8,486.56c-5.91-3.813-18.936,0-26.871,2.706s-22.545,7.754-25.249,15.328,6.673,15.512,7.935,20.922.181,18.825,8.116,23.084c9.739,5.231,44.367-1.623,50.136-15.87,3.609-8.913-5.231-18.576-7.574-23.447S1286.4,490.166,1280.8,486.56Z"
                          transform="translate(-1228.196 -484.952)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 27 })}
                      code={27}
                    >
                      <g
                        id="Group_8500"
                        data-name="Group 8500"
                        transform="translate(929.053 416.473)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee"
                          id="Path_22995"
                          data-name="Path 22995"
                          d="M1312.206,609.814c-8.117-4.508-18.216,1.8-24.71,2.706s-18.366,2.33-22.2,7.527c-5.592,7.574-2.506,39.186,7.412,46.76,4.641,3.542,14.8,3.743,25.43,1.262,12.1-2.824,21.748.2,26.979-9.9,3.271-6.316-3.172-18.057-4.616-24.729S1320.322,614.324,1312.206,609.814Z"
                          transform="translate(-1262.528 -608.206)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 28 })}
                      code={28}
                    >
                      <g
                        id="Group_8501"
                        data-name="Group 8501"
                        transform="translate(936.968 480.236)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee"
                          id="Path_22996"
                          data-name="Path 22996"
                          d="M1327.945,733.866c-6.43-6.433-36.738-2.882-43.178,4.224-10.657,11.76-9,33.993,3.306,44.832,10.173,8.958,36.932,6.981,43.732-1.1s1.1-15.8.367-23.7C1331.713,753.165,1334.378,740.3,1327.945,733.866Z"
                          transform="translate(-1277.708 -730.499)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 75 })}
                      code={75}
                    >
                      <g
                        id="Group_8502"
                        data-name="Group 8502"
                        transform="translate(855.848 631.326)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_22997"
                          className="stylehovee"
                          data-name="Path 22997"
                          d="M1131.187,942.33c-9.073,6.9-5.754,15.623-6.675,21.41s-4.624,13.7-.426,20.846c4.9,8.344,33.466,15.009,45.167,6.973,7.66-5.262,3.962-15.8,5.076-22.556s5.386-13.566.372-21.892C1170.794,940.623,1142.037,934.078,1131.187,942.33Z"
                          transform="translate(-1122.124 -938.46)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 74 })}
                      code={74}
                    >
                      <g
                        id="Group_8503"
                        data-name="Group 8503"
                        transform="translate(848.653 687.195)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_22998"
                          className="stylehovee"
                          data-name="Path 22998"
                          d="M1140.219,1049.169c-6.581-1.046-14.556-5.259-20.512-2.793s-5.291,14.063-6.815,19.394-6.5,12.27-3.763,19.294,13.185,8.409,19.019,10.1,14.085,5.587,21.227,1.662c7.259-3.988,4.846-13.345,6.192-18.367s8.126-11.489,4.794-20.151C1157.832,1051.731,1146.8,1050.217,1140.219,1049.169Z"
                          transform="translate(-1108.324 -1045.614)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 73 })}
                      code={73}
                    >
                      <g
                        id="Group_8504"
                        data-name="Group 8504"
                        transform="translate(841.297 738.335)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee3"
                          id="Path_22999"
                          data-name="Path 22999"
                          d="M1097.885,1146.522c-7.661,7.487-1.951,26.253,4.594,32.589s32.214-22.854,26.217-28.829S1103.546,1140.99,1097.885,1146.522Z"
                          transform="translate(-1094.215 -1143.699)"
                          fill="#94e7cb"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 72 })}
                      code={72}
                    >
                      <g
                        id="Group_8505"
                        data-name="Group 8505"
                        transform="translate(813.414 764.012)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_23000"
                          className="stylehovee4"
                          data-name="Path 23000"
                          d="M1046.153,1194.511c-11.152,7.282-1.941,27.147.014,31s28.266-17.788,28.266-17.788S1057.3,1187.231,1046.153,1194.511Z"
                          transform="translate(-1040.737 -1192.947)"
                          fill="#8ae6ab"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 71 })}
                      code={71}
                    >
                      <g
                        id="Group_8506"
                        data-name="Group 8506"
                        transform="translate(781.776 775.888)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_23001"
                          className="stylehovee4"
                          data-name="Path 23001"
                          d="M992.5,1215.794c-11.7,1.427-12.965,21.84-12.3,28.777s31.79-2.255,31.128-6.088S1004.2,1214.369,992.5,1215.794Z"
                          transform="translate(-980.056 -1215.723)"
                          fill="#8ae6ab"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      code={33}
                    >
                      <g
                        id="Group_8507"
                        data-name="Group 8507"
                        transform="translate(847.635 847.843)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee3"
                          id="Path_23002"
                          data-name="Path 23002"
                          d="M1112.745,1436.836c-9.025,5.77-7.256,25.306-2.139,32.842s36.193-15.815,31.538-22.886S1119.414,1432.574,1112.745,1436.836Z"
                          transform="translate(-1106.372 -1435.554)"
                          fill="#94e7cb"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 32 })}
                      code={32}
                    >
                      <g
                        id="Group_8508"
                        data-name="Group 8508"
                        transform="translate(816.281 867.429)"
                      >
                        <path
                          id="Path_23003"
                          className="stylehovee4"
                          data-name="Path 23003"
                          d="M1055.163,1473.645c-12.587,4.353-8.48,25.861-7.52,30.07s31.742-10.384,31.742-10.384S1067.748,1469.293,1055.163,1473.645Z"
                          transform="translate(-1046.236 -1473.118)"
                          fill="#8ae6ab"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 31 })}
                      code={31}
                    >
                      <g
                        id="Group_8509"
                        data-name="Group 8509"
                        transform="translate(782.033 875.063)"
                      >
                        <path
                          id="Path_23004"
                          className="stylehovee4"
                          data-name="Path 23004"
                          d="M995.626,1487.762c-11.786.264-15.057,20.454-15.076,27.422s31.857.893,31.576-2.987S1007.409,1487.5,995.626,1487.762Z"
                          transform="translate(-980.55 -1487.759)"
                          fill="#8ae6ab"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 38 })}
                      code={38}
                    >
                      <g
                        id="Group_8510"
                        data-name="Group 8510"
                        transform="translate(936.998 592.323)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_23005"
                          className="stylehovee"
                          data-name="Path 23005"
                          d="M1328.761,952.468c-4.918-8.269-16.2-4.707-23.494-4.9s-14.215-4.886-20.9.469-2.464,16.79-3.7,23.439-5.735,13.947-.193,21.812,17.026,5.655,23.288,6.147,15.334,4.308,22.22-1.484,2.02-16.185,2.142-22.252S1334.613,962.3,1328.761,952.468Z"
                          transform="translate(-1277.766 -945.477)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 37 })}
                      code={37}
                    >
                      <g
                        id="Group_8511"
                        data-name="Group 8511"
                        transform="translate(922.001 649.708)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_23006"
                          className="stylehovee"
                          data-name="Path 23006"
                          d="M1265.584,1057.661c-11.269,5.958-9.2,16.188-11.269,22.4s-7.6,14.269-4.272,22.921c3.886,10.1,34.187,22.663,48.562,15.93,9.411-4.409,7.253-16.708,9.714-23.96s8.416-13.985,4.4-24.085C1309.593,1063,1279.059,1050.536,1265.584,1057.661Z"
                          transform="translate(-1249.001 -1055.54)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 36 })}
                      code={36}
                    >
                      <g
                        id="Group_8512"
                        data-name="Group 8512"
                        transform="translate(902.101 711.248)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_23007"
                          className="stylehovee"
                          data-name="Path 23007"
                          d="M1255.4,1181.222c-7.68-2.538-16.412-9.14-24.027-7.349s-9.083,15.815-11.949,21.9-10.176,13.43-8.272,22.379,14.154,12.646,20.813,15.806,15.784,9.442,25.105,6.133c9.475-3.36,8.41-15.041,11-20.795s11.977-12.178,9.675-23.205C1276,1187.729,1263.078,1183.763,1255.4,1181.222Z"
                          transform="translate(-1210.835 -1173.57)"
                          fill="#fed3b6"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 35 })}
                      code={35}
                    >
                      <g
                        id="Group_8513"
                        className="stylehovee2"
                        data-name="Group 8513"
                        transform="translate(893.886 775.132)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_23008"
                          data-name="Path 23008"
                          d="M1222.351,1301.52c-3.749-1.311-8.467-5.975-14.234-5.369-4.718.494-14.738,18.672-12.79,28.159,1.489,7.259,8.881,8.136,13.328,10.539s6.4,6.711,13.625,6.14c9.614-.762,20.217-23.457,15.99-31.376S1226.1,1302.83,1222.351,1301.52Z"
                          transform="translate(-1195.079 -1296.097)"
                          fill="#ffe394"
                        />
                      </g>
                    </a>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 34 })}
                      code={34}
                    >
                      <g
                        id="Group_8514"
                        className="stylehovee2"
                        data-name="Group 8514"
                        transform="translate(871.162 813.489)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          id="Path_23009"
                          data-name="Path 23009"
                          d="M1181.576,1375.447c-6.192-3.794-8.1-6.752-14.174-5.487-7.192,1.5-17.183,17.314-15.774,24.308,1.122,5.563,3.631,7.348,9.114,11.027,5.719,3.839,9.583,9.06,15.959,7.45,8.76-2.212,18.541-18.866,16.7-27.26C1192.093,1379.486,1187.368,1379,1181.576,1375.447Z"
                          transform="translate(-1151.495 -1369.664)"
                          fill="#ffe394"
                        />
                      </g>
                    </a>
                    <g
                      id="Group_8515"
                      data-name="Group 8515"
                      transform="translate(781.174 330.39)"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_23010"
                        data-name="Path 23010"
                        d="M1004.358,511.512c-10.619-.925-25.176-1.8-25.451,5.116-.3,7.523,17.271,8.248,23.524,9.044s23.9,4.442,25.069-2.208C1028.4,518.339,1018.083,512.709,1004.358,511.512Z"
                        transform="translate(-978.903 -510.889)"
                        fill="#67c78a"
                      />
                    </g>
                    <g
                      id="Group_8516"
                      data-name="Group 8516"
                      transform="translate(831.433 342.202)"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_23011"
                        data-name="Path 23011"
                        d="M1094.811,541.446c-6.994-5.024-16.271-10.671-18.945-6.386-2.939,4.706,6.169,10.038,11.841,14.177,4.839,3.532,13.268,11.344,16.825,8.607S1101.806,546.471,1094.811,541.446Z"
                        transform="translate(-1075.296 -533.543)"
                        fill="#67c78a"
                      />
                    </g>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 63 })}
                      code={63}
                    >
                      <g
                        id="Group_8517"
                        data-name="Group 8517"
                        transform="translate(859.925 368.96)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee3"
                          id="Path_23012"
                          data-name="Path 23012"
                          d="M1131.308,586.254c-3.133,3.117.085,7.607.266,11.07.181,3.429-1.123,6.136.557,8.97s5.954,3.159,10.46,5.73c3.277,1.87,5.873,6.284,10.035,4.854,3.982-1.367,5.909-10.649-1.925-21.2C1142.824,585.07,1134.537,583.044,1131.308,586.254Z"
                          transform="translate(-1129.943 -584.863)"
                          fill="#46bc94"
                        />
                      </g>
                    </a>
                    <g
                      id="Group_8518"
                      data-name="Group 8518"
                      transform="translate(780.877 207.64)"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_23013"
                        data-name="Path 23013"
                        d="M1006.044,208.242c-11.561-.886-27.409-1.693-27.708,5.457-.324,7.775,18.8,8.405,25.612,9.186s26.019,4.429,27.293-2.449C1032.222,215.133,1020.987,209.386,1006.044,208.242Z"
                        transform="translate(-978.332 -207.674)"
                        fill="#67c78a"
                      />
                    </g>
                    <g
                      id="Group_8519"
                      data-name="Group 8519"
                      transform="translate(837.703 220.572)"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_23014"
                        data-name="Path 23014"
                        d="M1108.1,236.8c-8.238-3.358-18.919-6.79-20.57-1.84-1.816,5.437,8.62,8.592,15.316,11.38,5.712,2.379,16.065,8.19,18.977,4.583S1116.34,240.155,1108.1,236.8Z"
                        transform="translate(-1087.322 -232.476)"
                        fill="#67c78a"
                      />
                    </g>
                    <g
                      id="Group_8520"
                      data-name="Group 8520"
                      transform="translate(877.453 239.552)"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_23015"
                        data-name="Path 23015"
                        d="M1186.095,275.7c-10.759-8.4-19.567-8.143-21.9-4.06-2.263,3.965,2.174,7.552,3.306,10.951,1.123,3.365.568,6.419,3.02,8.779s6.8,1.51,11.989,2.832c3.778.961,7.575,4.644,11.327,2.077C1197.425,293.827,1196.794,284.053,1186.095,275.7Z"
                        transform="translate(-1163.56 -268.88)"
                        fill="#46bc94"
                      />
                    </g>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      code={11}
                    >
                      <g
                        id="Group_8521"
                        className="stylehovee3"
                        data-name="Group 8521"
                        transform="translate(849.033 745.302)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <g
                          id="Group_8521"
                          className="stylehovee3"
                          data-name="Group 8521"
                          transform="translate(849.033 745.302)"
                          style={{
                            isolation: "isolate",
                          }}
                        >
                          <path
                            id="Path_23016"
                            data-name="Path 23016"
                            d="M1136.977,1158.236c-4.125-3.6-6.406,2.094-10.228,3.365s-7.284,1.99-9.435,4.434c-2.883,3.27-.968,7.231-2.768,10.458s-7.721,5.868-4.6,9.413c4.1,4.658,13.3,1.321,21.352-7.007S1139.881,1160.771,1136.977,1158.236Z"
                            transform="translate(-1109.053 -1157.061)"
                            fill="#46bc94"
                          />
                        </g>
                      </g>
                    </a>
                    <g
                      id="Group_8522"
                      data-name="Group 8522"
                      transform="translate(818.499 778.069)"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_23017"
                        data-name="Path 23017"
                        d="M1063.132,1227.735c-3.424,2.441-14.749,6.007-12.3,10.209s7.107,2.232,17.232-3.78c9.587-5.691,14.645-9.762,11.336-13.351S1066.561,1225.3,1063.132,1227.735Z"
                        transform="translate(-1050.489 -1219.907)"
                        fill="#67c78a"
                      />
                    </g>
                    <g
                      id="Group_8523"
                      data-name="Group 8523"
                      transform="translate(782.83 798.787)"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_23018"
                        data-name="Path 23018"
                        d="M995.222,1257.807c-7.354,1.178-15.214.97-14.952,5.509.354,6.222,8.373,4.482,15.28,3.217s17.556-1.452,16.177-8.507C1011.058,1254.616,1002.573,1256.626,995.222,1257.807Z"
                        transform="translate(-980.263 -1256.134)"
                        fill="#67c78a"
                      />
                    </g>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      onClick={() => handleToothClick({ code: 33 })}
                      code={33}
                    >
                      <g
                        id="Group_8524"
                        data-name="Group 8524"
                        transform="translate(851.64 859.098)"
                        style={{
                          isolation: "isolate",
                        }}
                      >
                        <path
                          className="stylehovee3"
                          id="Path_23019"
                          data-name="Path 23019"
                          d="M1135.96,1460.1c-4,.465-7.536.465-10.141,2.42-3.488,2.614-2.42,6.883-4.839,9.676s-8.754,4.173-6.421,8.279c3.07,5.4,12.749,4,22.331-2.512s12.1-16,9.768-19.073C1143.353,1454.528,1139.961,1459.635,1135.96,1460.1Z"
                          transform="translate(-1114.052 -1457.139)"
                          fill="#46bc94"
                        />
                      </g>
                    </a>
                    <g
                      id="Group_8525"
                      data-name="Group 8525"
                      transform="translate(817.692 886.299)"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_23020"
                        data-name="Path 23020"
                        d="M1063.461,1513.671c-3.915,1.535-15.767,2.242-14.412,6.914s6.352,3.893,17.635.522c10.682-3.19,16.579-5.909,14.241-10.2S1067.38,1512.138,1063.461,1513.671Z"
                        transform="translate(-1048.942 -1509.31)"
                        fill="#67c78a"
                      />
                    </g>
                    <g
                      id="Group_8526"
                      data-name="Group 8526"
                      transform="translate(782.056 897.33)"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_23021"
                        data-name="Path 23021"
                        d="M996.023,1531.021c-7.434.446-15.235-.536-15.423,4.007-.261,6.226,7.89,5.285,14.888,4.709s17.613.287,16.938-6.87C1012.1,1529.408,1003.454,1530.572,996.023,1531.021Z"
                        transform="translate(-980.593 -1530.467)"
                        fill="#67c78a"
                      />
                    </g>
                    <g
                      id="Group_8527"
                      data-name="Group 8527"
                      transform="translate(592.613 488.377)"
                    >
                      <path
                        id="Path_23022"
                        data-name="Path 23022"
                        d="M620.068,752.1a46.393,46.393,0,0,0-1.8,6.559,53.607,53.607,0,0,0-.973,7.749c-.07,1.331-.049,2.669-.024,3.986,0,1.316.2,2.612.308,3.86a30.905,30.905,0,0,0,.675,3.574,20.22,20.22,0,0,0,.959,3.12,13.859,13.859,0,0,0,1.127,2.517,10.634,10.634,0,0,0,1.094,1.811c.7.945,1.12,1.445,1.12,1.445L622.006,785a16.137,16.137,0,0,1-.523-1.965,21.774,21.774,0,0,1-.5-2.558c-.184-.93-.258-1.965-.38-3.043-.155-1.07-.105-2.239-.225-3.412-.023-2.378-.088-4.912.1-7.456.071-2.546.341-5.089.559-7.481.249-2.39.533-4.622.8-6.542s.541-3.511.736-4.638l.351-1.786s-.363.557-.939,1.558A32.584,32.584,0,0,0,620.068,752.1Z"
                        transform="translate(-617.252 -746.115)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8529"
                      data-name="Group 8529"
                      transform="translate(575.135 507.668)"
                    >
                      <g id="Group_8528" data-name="Group 8528">
                        <path
                          id="Path_23023"
                          data-name="Path 23023"
                          d="M586.722,783.46c-1.8-.034-2.992-.162-2.992-.162s1.158.324,2.937.657,4.156.732,6.541,1.08c4.768.7,9.561,1.267,9.561,1.267l.112-3.188s-4.782.234-9.573.33C590.912,783.494,588.516,783.506,586.722,783.46Z"
                          transform="translate(-583.73 -783.114)"
                          fill="#e18446"
                        />
                      </g>
                    </g>
                    <g
                      id="Group_8530"
                      data-name="Group 8530"
                      transform="translate(595.242 428.789)"
                    >
                      <path
                        id="Path_23024"
                        data-name="Path 23024"
                        d="M623.319,650.949a57.792,57.792,0,0,0-.953,7.542,37.426,37.426,0,0,0,.156,6.661,22.969,22.969,0,0,0,.921,4.627c.357,1.086.589,1.682.589,1.682s.014-.644.039-1.771.089-2.689.282-4.56c.153-1.869.47-4.037.805-6.349.382-2.309.768-4.776,1.288-7.225.421-2.468,1.01-4.906,1.465-7.22.513-2.308.991-4.46,1.4-6.306.822-3.7,1.469-6.2,1.469-6.2a28.7,28.7,0,0,0-3.195,5.618A61.654,61.654,0,0,0,623.319,650.949Z"
                        transform="translate(-622.293 -631.827)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8531"
                      data-name="Group 8531"
                      transform="translate(609.221 368.084)"
                    >
                      <path
                        id="Path_23025"
                        data-name="Path 23025"
                        d="M651.224,533.751a57.72,57.72,0,0,0-1.643,7.423,37.413,37.413,0,0,0-.458,6.647,22.954,22.954,0,0,0,.491,4.693c.256,1.114.431,1.73.431,1.73s.074-.64.2-1.76.336-2.669.7-4.515c.325-1.847.84-3.976,1.386-6.248.593-2.264,1.2-4.685,1.948-7.076.647-2.418,1.459-4.792,2.124-7.053l1.976-6.15c1.159-3.6,2.036-6.042,2.036-6.042a28.693,28.693,0,0,0-3.7,5.3A61.682,61.682,0,0,0,651.224,533.751Z"
                        transform="translate(-649.104 -515.398)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8532"
                      data-name="Group 8532"
                      transform="translate(578.941 444.862)"
                    >
                      <path
                        id="Path_23026"
                        data-name="Path 23026"
                        d="M624.443,668.778c-.719-.035-1.515-.027-2.391-.116a97.376,97.376,0,0,1-12.615-1.862c-2.286-.436-4.555-.981-6.7-1.46l-5.874-1.381c-3.451-.82-5.834-1.3-5.834-1.3a33.752,33.752,0,0,0,5.223,3.021,55.085,55.085,0,0,0,12.549,4.247,46.514,46.514,0,0,0,7.084.872,30.069,30.069,0,0,0,6.248-.3,17.271,17.271,0,0,0,2.453-.5,10.363,10.363,0,0,0,1.838-.57c1-.383,1.545-.628,1.545-.628l-1.66.005A17.685,17.685,0,0,1,624.443,668.778Z"
                        transform="translate(-591.029 -662.655)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8533"
                      data-name="Group 8533"
                      transform="translate(596.041 380.119)"
                    >
                      <path
                        id="Path_23027"
                        data-name="Path 23027"
                        d="M655.311,551.224c-.7-.18-1.478-.333-2.318-.6a97.307,97.307,0,0,1-11.977-4.371c-2.15-.888-4.262-1.881-6.267-2.783l-5.474-2.539c-3.213-1.5-5.45-2.455-5.45-2.455a33.824,33.824,0,0,0,4.5,4.013,55.06,55.06,0,0,0,11.432,6.693,46.35,46.35,0,0,0,6.76,2.285,30.057,30.057,0,0,0,6.179.964,17.268,17.268,0,0,0,2.5,0,10.407,10.407,0,0,0,1.915-.187c1.055-.174,1.639-.3,1.639-.3l-1.626-.33A17.687,17.687,0,0,1,655.311,551.224Z"
                        transform="translate(-623.826 -538.48)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8534"
                      data-name="Group 8534"
                      transform="translate(667.14 466.544)"
                    >
                      <path
                        id="Path_23028"
                        data-name="Path 23028"
                        d="M760.216,789.351a45.994,45.994,0,0,0,.234,6.606,29.643,29.643,0,0,0,1.151,5.687,18.133,18.133,0,0,0,1.563,3.8c.5.864.8,1.328.8,1.328s-.073-.555-.2-1.527c-.131-.957-.285-2.312-.365-3.934a118.231,118.231,0,0,1,0-11.842c.027-2.159.208-4.316.28-6.352.12-2.039.233-3.942.33-5.574.224-3.311.374-5.518.374-5.518a22.816,22.816,0,0,0-2.166,5.189A48.693,48.693,0,0,0,760.216,789.351Z"
                        transform="translate(-760.191 -772.026)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8535"
                      data-name="Group 8535"
                      transform="translate(674.623 416.995)"
                    >
                      <path
                        id="Path_23029"
                        data-name="Path 23029"
                        d="M780.906,681.337a47.514,47.514,0,0,0-4.686,10.84,45.416,45.416,0,0,0-1.34,6.2,29.439,29.439,0,0,0-.3,5.56,18.189,18.189,0,0,0,.509,3.917c.243.927.411,1.435.411,1.435l.222-1.466c.132-.92.349-2.214.683-3.739.647-3.05,1.677-7.041,2.877-11.014.531-2.005,1.2-3.975,1.729-5.858l1.562-5.133,1.552-5.086A22.159,22.159,0,0,0,780.906,681.337Z"
                        transform="translate(-774.543 -676.993)"
                        fill="#e18446"
                      />
                    </g>
                    <a
                      xlinkHref="javascript:void(0);"
                      className="TeethLink"
                      code={55}
                    >
                      <g
                        id="Group_8536"
                        data-name="Group 8536"
                        transform="translate(652.104 482.715)"
                      >
                        <path
                          id="Path_23030"
                          data-name="Path 23030"
                          d="M759.77,803.736a96.423,96.423,0,0,1-11.45.2c-2.09-.036-4.182-.173-6.156-.258l-5.422-.284c-3.188-.165-5.39-.181-5.39-.181a28.706,28.706,0,0,0,5.077,1.976,47.393,47.393,0,0,0,11.79,1.93,40.651,40.651,0,0,0,6.433-.321,26.34,26.34,0,0,0,5.505-1.27,15.131,15.131,0,0,0,2.1-.848,9.2,9.2,0,0,0,1.539-.813c.822-.509,1.264-.822,1.264-.822l-1.483.227C762.662,803.456,761.327,803.578,759.77,803.736Z"
                          transform="translate(-731.353 -803.041)"
                          fill="#e18446"
                        />
                      </g>
                    </a>
                    <g
                      id="Group_8537"
                      data-name="Group 8537"
                      transform="translate(663.838 427.001)"
                    >
                      <path
                        id="Path_23031"
                        data-name="Path 23031"
                        d="M777.73,704.083l-4.616-1.261c-1.668-.487-3.449-.96-5.193-1.554-3.519-1.08-6.975-2.356-9.607-3.367l-4.458-1.717a19.914,19.914,0,0,0,3.572,3.31,32.662,32.662,0,0,0,9.534,4.813,36.053,36.053,0,0,0,5.577,1.263,31.322,31.322,0,0,0,4.965.33,23.736,23.736,0,0,0,3.512-.269c.844-.126,1.322-.227,1.322-.227s-.468-.167-1.279-.406Z"
                        transform="translate(-753.857 -696.183)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8538"
                      className="stylehovee"
                      data-name="Group 8538"
                      transform="translate(886.891 464.856)"
                    >
                      <path
                        id="Path_23032"
                        data-name="Path 23032"
                        d="M1183.768,774.244a24.806,24.806,0,0,0-2.07-5.456s.109,2.3.271,5.742c.069,1.7.149,3.682.235,5.807.038,2.119.188,4.369.184,6.619.14,4.5.077,8.97-.137,12.341-.094,1.689-.25,3.1-.383,4.095-.13,1.01-.2,1.588-.2,1.588s.308-.489.808-1.394a20.124,20.124,0,0,0,1.58-3.959,32.629,32.629,0,0,0,1.2-5.893,50.416,50.416,0,0,0,.32-6.849A53.2,53.2,0,0,0,1183.768,774.244Z"
                        transform="translate(-1181.663 -768.788)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8539"
                      data-name="Group 8539"
                      transform="translate(874.38 416.995)"
                    >
                      <path
                        id="Path_23033"
                        data-name="Path 23033"
                        d="M1165.569,692.177a47.49,47.49,0,0,0-4.686-10.84,22.159,22.159,0,0,0-3.216-4.344s.62,2.035,1.552,5.086c.457,1.5.99,3.255,1.562,5.133.53,1.883,1.2,3.853,1.729,5.858,1.2,3.974,2.231,7.964,2.877,11.014.334,1.525.551,2.819.682,3.739l.222,1.466s.168-.508.411-1.435a18.148,18.148,0,0,0,.508-3.917,29.426,29.426,0,0,0-.3-5.56A45.512,45.512,0,0,0,1165.569,692.177Z"
                        transform="translate(-1157.667 -676.993)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8540"
                      data-name="Group 8540"
                      transform="translate(872.772 482.715)"
                    >
                      <path
                        id="Path_23034"
                        data-name="Path 23034"
                        d="M1177.476,803.674c-1.974.085-4.066.222-6.156.258a96.437,96.437,0,0,1-11.45-.2c-1.556-.159-2.892-.28-3.805-.468l-1.482-.227s.442.313,1.264.822a9.214,9.214,0,0,0,1.538.813,15.109,15.109,0,0,0,2.1.848,26.341,26.341,0,0,0,5.505,1.27,40.652,40.652,0,0,0,6.433.321,47.386,47.386,0,0,0,11.79-1.93,28.7,28.7,0,0,0,5.078-1.976s-2.2.016-5.39.181Z"
                        transform="translate(-1154.583 -803.041)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8541"
                      data-name="Group 8541"
                      transform="translate(866.263 427.001)"
                    >
                      <path
                        id="Path_23035"
                        data-name="Path 23035"
                        d="M1156.515,701.268c-1.744.593-3.525,1.066-5.193,1.554l-4.616,1.261-3.328.914c-.811.239-1.279.406-1.279.406s.478.1,1.322.227a23.738,23.738,0,0,0,3.512.269,31.333,31.333,0,0,0,4.965-.33,36.04,36.04,0,0,0,5.576-1.263,32.658,32.658,0,0,0,9.534-4.813,19.893,19.893,0,0,0,3.572-3.31l-4.458,1.717C1163.49,698.912,1160.034,700.188,1156.515,701.268Z"
                        transform="translate(-1142.1 -696.183)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8542"
                      data-name="Group 8542"
                      transform="translate(624.407 319.047)"
                    >
                      <path
                        id="Path_23036"
                        data-name="Path 23036"
                        d="M688.363,422.03a10.512,10.512,0,0,0-1.292-.682l.865,1.147a9.031,9.031,0,0,1,1.55,3.084,4.973,4.973,0,0,1,.033,2.013,12.032,12.032,0,0,1-.868,2.285c-.8,1.761-1.537,3.682-2.285,5.6l-1.978,5.6a19.893,19.893,0,0,1-2.074,4.413,4.873,4.873,0,0,1-2.721,1.814l-1.363.486s.522.07,1.445.142a6.8,6.8,0,0,0,1.747-.078,4.927,4.927,0,0,0,2.188-1.073,14.062,14.062,0,0,0,3.342-4.565,53.788,53.788,0,0,0,2.409-5.658c.685-1.94,1.378-3.876,1.922-5.73a9.859,9.859,0,0,0,.6-3.053,5.888,5.888,0,0,0-.7-2.866A7.6,7.6,0,0,0,688.363,422.03Z"
                        transform="translate(-678.231 -421.348)"
                        fill="#e49d3c"
                      />
                    </g>
                    <g
                      id="Group_8543"
                      data-name="Group 8543"
                      transform="translate(630.14 323.051)"
                    >
                      <path
                        id="Path_23037"
                        data-name="Path 23037"
                        d="M698.735,429.219a6.48,6.48,0,0,0-2.647,1.139,5.7,5.7,0,0,0-1.928,2.713c-.794,1.746-1.53,3.651-2.275,5.553a56.792,56.792,0,0,0-1.909,5.8,19.593,19.593,0,0,0-.743,5.449,5.51,5.51,0,0,0,1.4,3.794,12.352,12.352,0,0,0,1.082.973l-.548-1.315a5.442,5.442,0,0,1-.106-3.309c.672-2.8,2.3-6.408,3.79-10.215.681-1.928,1.373-3.851,1.916-5.7a4.12,4.12,0,0,1,.872-1.949,5.987,5.987,0,0,1,1.674-1.2,13.883,13.883,0,0,1,3.357-1.079c.865-.167,1.4-.221,1.4-.221a7.886,7.886,0,0,0-1.4-.41A9.772,9.772,0,0,0,698.735,429.219Z"
                        transform="translate(-689.226 -429.027)"
                        fill="#e49d3c"
                      />
                    </g>
                    <g
                      id="Group_8544"
                      data-name="Group 8544"
                      transform="translate(643.889 280.736)"
                    >
                      <path
                        id="Path_23038"
                        data-name="Path 23038"
                        d="M728.309,348.971l-.548-1.1a10.492,10.492,0,0,0-.068,1.24,23.9,23.9,0,0,1-.163,3.072,14.9,14.9,0,0,1-1.12,3.9,28.666,28.666,0,0,1-2.328,4.176c-1.8,2.952-3.364,5.916-5.027,7.591a9.683,9.683,0,0,1-2.369,1.78c-.665.364-1.09.546-1.09.546a6.13,6.13,0,0,0,1.252.067,7.18,7.18,0,0,0,3.287-.915c2.637-1.4,4.843-4.468,6.667-7.409a18.871,18.871,0,0,0,2.258-4.93,10.877,10.877,0,0,0-.751-8.014Z"
                        transform="translate(-715.596 -347.868)"
                        fill="#e49d3c"
                      />
                    </g>
                    <g
                      id="Group_8545"
                      data-name="Group 8545"
                      transform="translate(649.475 285.38)"
                    >
                      <path
                        id="Path_23039"
                        data-name="Path 23039"
                        d="M735.884,357.355a11.655,11.655,0,0,0-3.724,2.963,27.982,27.982,0,0,0-3.013,4.265c-1.687,2.968-3.141,6.5-2.784,9.464a7.731,7.731,0,0,0,1.129,3.144c.4.66.665,1.019.665,1.019s-.007-.45-.06-1.21a11.378,11.378,0,0,1,.1-2.92,15.665,15.665,0,0,1,1.4-3.717c.709-1.362,1.429-2.727,2.331-4.219,1.633-2.849,3.27-5.718,4.936-7.25a7.158,7.158,0,0,1,2.447-1.444l1.13-.42a11.44,11.44,0,0,0-1.2-.206A6.047,6.047,0,0,0,735.884,357.355Z"
                        transform="translate(-726.309 -356.776)"
                        fill="#e49d3c"
                      />
                    </g>
                    <g
                      id="Group_8546"
                      data-name="Group 8546"
                      transform="translate(961.851 488.377)"
                    >
                      <path
                        id="Path_23040"
                        data-name="Path 23040"
                        d="M1330.084,758.66a46.3,46.3,0,0,0-1.8-6.559,32.655,32.655,0,0,0-1.917-4.427c-.576-1-.939-1.558-.939-1.558s.128.65.35,1.786c.195,1.128.46,2.715.737,4.638s.547,4.152.8,6.542c.218,2.392.487,4.935.559,7.481.189,2.544.124,5.078.1,7.456-.119,1.173-.069,2.342-.224,3.412-.122,1.079-.2,2.113-.38,3.043a21.562,21.562,0,0,1-.5,2.558,16.115,16.115,0,0,1-.523,1.965l-.551,1.725s.416-.5,1.119-1.445a10.618,10.618,0,0,0,1.094-1.811,13.863,13.863,0,0,0,1.127-2.517,20.221,20.221,0,0,0,.958-3.12,30.776,30.776,0,0,0,.675-3.574c.11-1.248.309-2.544.309-3.86.024-1.316.045-2.654-.025-3.986A53.734,53.734,0,0,0,1330.084,758.66Z"
                        transform="translate(-1325.433 -746.115)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8548"
                      data-name="Group 8548"
                      transform="translate(965.621 507.527)"
                    >
                      <g id="Group_8547" data-name="Group 8547">
                        <path
                          id="Path_23041"
                          data-name="Path 23041"
                          d="M1342.4,782.844c-2.411.006-4.825.05-6.658.14-.9.037-1.732.112-2.26.159l-.822.088.607,3.132.8-.224c.5-.131,1.148-.3,2.031-.486,1.729-.38,4.081-.819,6.443-1.22,4.724-.81,9.486-1.482,9.486-1.482S1347.222,782.828,1342.4,782.844Z"
                          transform="translate(-1332.663 -782.842)"
                          fill="#e18446"
                        />
                      </g>
                    </g>
                    <g
                      id="Group_8549"
                      data-name="Group 8549"
                      transform="translate(956.406 428.789)"
                    >
                      <path
                        id="Path_23042"
                        data-name="Path 23042"
                        d="M1322.452,650.949a61.679,61.679,0,0,0-4.269-13.5,28.669,28.669,0,0,0-3.195-5.618s.647,2.508,1.469,6.2c.41,1.846.888,4,1.4,6.306.455,2.313,1.044,4.752,1.466,7.22.52,2.449.907,4.916,1.288,7.225.335,2.313.652,4.481.8,6.349.193,1.871.261,3.447.281,4.56s.04,1.771.04,1.771.23-.6.589-1.682a23.009,23.009,0,0,0,.921-4.627,37.463,37.463,0,0,0,.157-6.661A57.876,57.876,0,0,0,1322.452,650.949Z"
                        transform="translate(-1314.989 -631.827)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8550"
                      data-name="Group 8550"
                      transform="translate(939.603 368.084)"
                    >
                      <path
                        id="Path_23043"
                        data-name="Path 23043"
                        d="M1291.955,533.751a61.675,61.675,0,0,0-5.495-13.054,28.677,28.677,0,0,0-3.7-5.3s.876,2.438,2.035,6.042c.578,1.8,1.253,3.9,1.976,6.15.666,2.262,1.478,4.635,2.125,7.053.743,2.392,1.356,4.812,1.948,7.076.547,2.272,1.062,4.4,1.387,6.248.364,1.845.578,3.408.7,4.515s.2,1.76.2,1.76.175-.616.431-1.73a22.909,22.909,0,0,0,.491-4.693,37.461,37.461,0,0,0-.458-6.647A57.886,57.886,0,0,0,1291.955,533.751Z"
                        transform="translate(-1282.761 -515.398)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8551"
                      data-name="Group 8551"
                      transform="translate(944.257 444.862)"
                    >
                      <path
                        id="Path_23044"
                        data-name="Path 23044"
                        d="M1316.918,665.341c-2.146.479-4.415,1.024-6.7,1.46a97.381,97.381,0,0,1-12.615,1.862c-.876.089-1.671.08-2.391.116a17.685,17.685,0,0,1-1.865.019l-1.659-.005s.546.245,1.544.628a10.374,10.374,0,0,0,1.839.57,17.276,17.276,0,0,0,2.452.5,30.07,30.07,0,0,0,6.248.3,46.5,46.5,0,0,0,7.083-.872,55.085,55.085,0,0,0,12.55-4.247,33.763,33.763,0,0,0,5.223-3.021s-2.383.485-5.834,1.3Z"
                        transform="translate(-1291.688 -662.655)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8552"
                      data-name="Group 8552"
                      transform="translate(929.162 380.119)"
                    >
                      <path
                        id="Path_23045"
                        data-name="Path 23045"
                        d="M1286.746,543.474c-2,.9-4.116,1.894-6.266,2.783a97.343,97.343,0,0,1-11.977,4.371c-.84.264-1.621.417-2.318.6a17.668,17.668,0,0,1-1.824.4l-1.626.33s.585.129,1.64.3a10.4,10.4,0,0,0,1.915.187,17.26,17.26,0,0,0,2.5,0,30.057,30.057,0,0,0,6.179-.964,46.4,46.4,0,0,0,6.76-2.285,55.057,55.057,0,0,0,11.432-6.693,33.768,33.768,0,0,0,4.5-4.013s-2.236.956-5.45,2.455Z"
                        transform="translate(-1262.736 -538.48)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8553"
                      data-name="Group 8553"
                      transform="translate(922.076 319.047)"
                    >
                      <path
                        id="Path_23046"
                        data-name="Path 23046"
                        d="M1258.715,445.488a19.89,19.89,0,0,1-2.074-4.413c-.631-1.787-1.3-3.694-1.978-5.6-.748-1.917-1.486-3.837-2.285-5.6a12.01,12.01,0,0,1-.868-2.285,4.964,4.964,0,0,1,.033-2.013,9.023,9.023,0,0,1,1.551-3.084l.865-1.147a10.555,10.555,0,0,0-1.292.682,7.61,7.61,0,0,0-2.819,2.879,5.9,5.9,0,0,0-.7,2.866,9.9,9.9,0,0,0,.6,3.053c.545,1.854,1.238,3.79,1.922,5.73a53.879,53.879,0,0,0,2.409,5.658,14.055,14.055,0,0,0,3.343,4.565,4.92,4.92,0,0,0,2.188,1.073,6.8,6.8,0,0,0,1.746.078c.923-.072,1.445-.142,1.445-.142l-1.363-.486A4.872,4.872,0,0,1,1258.715,445.488Z"
                        transform="translate(-1249.145 -421.348)"
                        fill="#e49d3c"
                      />
                    </g>
                    <g
                      id="Group_8554"
                      data-name="Group 8554"
                      transform="translate(915.151 323.051)"
                    >
                      <path
                        id="Path_23047"
                        data-name="Path 23047"
                        d="M1248.049,438.623c-.744-1.9-1.48-3.807-2.274-5.553a5.707,5.707,0,0,0-1.927-2.713,6.483,6.483,0,0,0-2.646-1.139,9.771,9.771,0,0,0-3.94.02,7.864,7.864,0,0,0-1.4.41s.539.053,1.4.221a13.871,13.871,0,0,1,3.356,1.079,5.976,5.976,0,0,1,1.674,1.2,4.132,4.132,0,0,1,.872,1.949c.543,1.845,1.234,3.768,1.916,5.7,1.493,3.807,3.118,7.417,3.79,10.215a5.435,5.435,0,0,1-.106,3.309l-.547,1.315a12.39,12.39,0,0,0,1.082-.973,5.51,5.51,0,0,0,1.4-3.794,19.572,19.572,0,0,0-.743-5.449A56.647,56.647,0,0,0,1248.049,438.623Z"
                        transform="translate(-1235.864 -429.027)"
                        fill="#e49d3c"
                      />
                    </g>
                    <g
                      id="Group_8555"
                      data-name="Group 8555"
                      transform="translate(902.343 280.736)"
                    >
                      <path
                        id="Path_23048"
                        data-name="Path 23048"
                        d="M1221.745,367.847c-1.663-1.675-3.226-4.639-5.028-7.591a28.7,28.7,0,0,1-2.328-4.176,14.878,14.878,0,0,1-1.121-3.9,23.885,23.885,0,0,1-.162-3.072,10.42,10.42,0,0,0-.068-1.24l-.548,1.1a10.873,10.873,0,0,0-.75,8.014,18.842,18.842,0,0,0,2.258,4.93c1.824,2.942,4.03,6.008,6.667,7.409a7.179,7.179,0,0,0,3.286.915,6.137,6.137,0,0,0,1.252-.067s-.425-.182-1.09-.546A9.692,9.692,0,0,1,1221.745,367.847Z"
                        transform="translate(-1211.3 -347.868)"
                        fill="#e49d3c"
                      />
                    </g>
                    <g
                      id="Group_8556"
                      data-name="Group 8556"
                      transform="translate(896.533 285.38)"
                    >
                      <path
                        id="Path_23049"
                        data-name="Path 23049"
                        d="M1208.434,360.318a11.652,11.652,0,0,0-3.724-2.963,6.048,6.048,0,0,0-3.349-.531,11.4,11.4,0,0,0-1.2.206l1.13.42a7.161,7.161,0,0,1,2.448,1.444c1.666,1.532,3.3,4.4,4.935,7.25.9,1.491,1.622,2.857,2.331,4.219a15.66,15.66,0,0,1,1.4,3.717,11.38,11.38,0,0,1,.1,2.92c-.053.76-.059,1.21-.059,1.21s.26-.36.664-1.019a7.732,7.732,0,0,0,1.129-3.144c.358-2.963-1.1-6.5-2.784-9.464A27.94,27.94,0,0,0,1208.434,360.318Z"
                        transform="translate(-1200.156 -356.776)"
                        fill="#e49d3c"
                      />
                    </g>
                    <g
                      id="Group_8557"
                      data-name="Group 8557"
                      transform="translate(592.631 601.037)"
                    >
                      <path
                        id="Path_23050"
                        data-name="Path 23050"
                        d="M621.759,994.149c-.271-1.751-.5-3.8-.708-6-.192-2.2-.4-4.543-.5-6.9-.285-4.709-.44-9.45-.568-13.034-.131-3.616-.218-6.027-.218-6.027a29.272,29.272,0,0,0-1.6,5.891,57.938,57.938,0,0,0-.8,13.352,52.54,52.54,0,0,0,.9,7.128,34.656,34.656,0,0,0,1.716,6.056,22.36,22.36,0,0,0,1.928,4.018c.575.915.923,1.409.923,1.409l-.334-1.642C622.273,997.378,622.02,995.9,621.759,994.149Z"
                        transform="translate(-617.286 -962.19)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8558"
                      data-name="Group 8558"
                      transform="translate(579.13 617.97)"
                    >
                      <path
                        id="Path_23051"
                        data-name="Path 23051"
                        d="M619.81,995.48c-.593.135-1.229.331-1.959.458a101.988,101.988,0,0,1-10.612,1.511l-10.821,1.018c-2.981.289-5.026.617-5.026.617a27.327,27.327,0,0,0,4.972,1.2,40.767,40.767,0,0,0,5.2.5,48.371,48.371,0,0,0,6-.165,38.827,38.827,0,0,0,5.942-1.089,24.182,24.182,0,0,0,4.97-1.868,13.314,13.314,0,0,0,1.843-1.069,7.851,7.851,0,0,0,1.319-.973c.69-.6,1.05-.952,1.05-.952l-1.352.394A13.334,13.334,0,0,1,619.81,995.48Z"
                        transform="translate(-591.392 -994.667)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8559"
                      data-name="Group 8559"
                      transform="translate(599.305 661.801)"
                    >
                      <path
                        id="Path_23052"
                        data-name="Path 23052"
                        d="M636.65,1110.137a109.4,109.4,0,0,1-2.686-12.587c-.4-2.314-.724-4.647-1.047-6.84s-.6-4.26-.847-6.023l-.861-5.954a31.13,31.13,0,0,0-.96,6.007,57.517,57.517,0,0,0,.571,13.326,49.658,49.658,0,0,0,1.685,6.977,31.053,31.053,0,0,0,2.456,5.8,19.719,19.719,0,0,0,2.494,3.692c.713.809,1.136,1.239,1.136,1.239s-.215-.569-.591-1.564C637.6,1113.247,637.149,1111.821,636.65,1110.137Z"
                        transform="translate(-630.087 -1078.733)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8560"
                      data-name="Group 8560"
                      transform="translate(585.276 676.421)"
                    >
                      <path
                        id="Path_23053"
                        data-name="Path 23053"
                        d="M634.118,1106.827a37.528,37.528,0,0,0-6.337.225,54.371,54.371,0,0,0-7.124,1.319,50.275,50.275,0,0,0-12.56,5.031,26.211,26.211,0,0,0-3.7,2.57c-.793.726-1.219,1.175-1.219,1.175l1.565-.649c.994-.371,2.39-.879,4.1-1.436,3.416-1.106,7.987-2.452,12.6-3.606,4.6-1.219,9.24-2.2,12.774-2.8,1.766-.314,3.259-.506,4.315-.629l1.678-.2s-.586-.175-1.644-.431A23.733,23.733,0,0,0,634.118,1106.827Z"
                        transform="translate(-603.179 -1106.773)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8561"
                      data-name="Group 8561"
                      transform="translate(615.365 726.761)"
                    >
                      <path
                        id="Path_23054"
                        data-name="Path 23054"
                        d="M667.645,1222.1a103.979,103.979,0,0,1-4.762-12.724L661.526,1205l-.556-1.676a36.322,36.322,0,0,0,.128,6.412,42.117,42.117,0,0,0,1.13,6.506c.328,1.165.623,2.394,1.085,3.586.424,1.207.926,2.4,1.437,3.6.576,1.164,1.15,2.331,1.791,3.435.591,1.133,1.338,2.148,1.991,3.165a46.622,46.622,0,0,0,4.12,5.14,40.7,40.7,0,0,0,4.647,4.411s-1.233-2.273-3.177-5.5A125.287,125.287,0,0,1,667.645,1222.1Z"
                        transform="translate(-660.888 -1203.324)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8562"
                      data-name="Group 8562"
                      transform="translate(605.981 737.335)"
                    >
                      <path
                        id="Path_23055"
                        data-name="Path 23055"
                        d="M669.5,1223.9a37.786,37.786,0,0,0-5.877,1.26,48.8,48.8,0,0,0-6.449,2.448,45.651,45.651,0,0,0-5.979,3.467,32.852,32.852,0,0,0-4.645,3.854,23.622,23.622,0,0,0-2.776,3.243l-.883,1.345,1.333-.9c.851-.589,2.013-1.359,3.462-2.26a106.1,106.1,0,0,1,10.852-5.866c4.047-1.919,8.209-3.62,11.407-4.812l5.406-2A26.34,26.34,0,0,0,669.5,1223.9Z"
                        transform="translate(-642.891 -1223.604)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8563"
                      data-name="Group 8563"
                      transform="translate(672.671 641.085)"
                    >
                      <path
                        id="Path_23056"
                        data-name="Path 23056"
                        d="M774.444,985.655a109.732,109.732,0,0,1-.46-11.474c-.022-2.1.032-4.2.053-6.176s.056-3.845.079-5.435c.008-3.235.013-5.392.013-5.392a26.391,26.391,0,0,0-1.819,5.147,49,49,0,0,0-1.512,11.853,43.054,43.054,0,0,0,.489,6.416,26.96,26.96,0,0,0,1.375,5.48,17.139,17.139,0,0,0,1.725,3.611c.53.813.852,1.247.852,1.247l-.261-1.477C774.78,988.542,774.618,987.214,774.444,985.655Z"
                        transform="translate(-770.798 -957.178)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8564"
                      data-name="Group 8564"
                      transform="translate(658.989 655.39)"
                    >
                      <path
                        id="Path_23057"
                        data-name="Path 23057"
                        d="M773.368,985.46a32.436,32.436,0,0,0-5.633-.777,47.086,47.086,0,0,0-6.492.1,43.184,43.184,0,0,0-11.826,2.683,22.623,22.623,0,0,0-3.627,1.789c-.8.543-1.233.891-1.233.891l1.489-.314c.936-.165,2.246-.384,3.842-.606,3.18-.435,7.4-.925,11.633-1.269,4.225-.405,8.451-.624,11.653-.68,1.6-.04,2.949-.016,3.9.011l1.517.033s-.488-.253-1.38-.653A20.636,20.636,0,0,0,773.368,985.46Z"
                        transform="translate(-744.557 -984.614)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8565"
                      data-name="Group 8565"
                      transform="translate(682.135 697.863)"
                    >
                      <path
                        id="Path_23058"
                        data-name="Path 23058"
                        d="M793.269,1082.122a102.012,102.012,0,0,1-2.4-10.888c-.512-3.039-.962-5.159-.962-5.159a26.918,26.918,0,0,0-.859,5.245,32.421,32.421,0,0,0,.023,5.467,30.311,30.311,0,0,0,.415,3.077c.192,1.042.451,2.087.715,3.132.327,1.026.655,2.053,1.043,3.036.343,1,.841,1.921,1.254,2.833a35.465,35.465,0,0,0,2.8,4.679,29.808,29.808,0,0,0,3.375,4.1s-.64-2.055-1.758-4.954C795.816,1089.774,794.357,1085.984,793.269,1082.122Z"
                        transform="translate(-788.949 -1066.075)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8566"
                      data-name="Group 8566"
                      transform="translate(671.533 710.823)"
                    >
                      <path
                        id="Path_23059"
                        data-name="Path 23059"
                        d="M781.73,1092.25a35.512,35.512,0,0,0-5.338,2.068,25.449,25.449,0,0,0-4.271,2.606,18.237,18.237,0,0,0-2.641,2.364c-.561.635-.864,1.022-.864,1.022s.461-.172,1.236-.513c.79-.342,1.85-.774,3.161-1.284,2.6-1.029,6.074-2.193,9.6-3.2s7.106-1.9,9.85-2.511,4.647-1.073,4.647-1.073a19.861,19.861,0,0,0-4.8-.751A33.163,33.163,0,0,0,781.73,1092.25Z"
                        transform="translate(-768.616 -1090.932)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8567"
                      data-name="Group 8567"
                      transform="translate(882.848 641.085)"
                    >
                      <path
                        id="Path_23060"
                        data-name="Path 23060"
                        d="M1175.019,957.178s.005,2.157.014,5.392c.022,1.591.05,3.447.079,5.435s.075,4.08.053,6.176a109.591,109.591,0,0,1-.46,11.474c-.174,1.559-.336,2.886-.533,3.8l-.262,1.477s.322-.434.852-1.247a17.2,17.2,0,0,0,1.725-3.611,26.967,26.967,0,0,0,1.374-5.48,43.028,43.028,0,0,0,.49-6.416,49.026,49.026,0,0,0-1.513-11.853A26.384,26.384,0,0,0,1175.019,957.178Z"
                        transform="translate(-1173.909 -957.178)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8568"
                      data-name="Group 8568"
                      transform="translate(866.935 655.39)"
                    >
                      <path
                        id="Path_23061"
                        data-name="Path 23061"
                        d="M1172.564,987.471a43.187,43.187,0,0,0-11.825-2.683,47.091,47.091,0,0,0-6.492-.1,32.435,32.435,0,0,0-5.634.777,20.628,20.628,0,0,0-3.845,1.212c-.893.4-1.38.653-1.38.653l1.517-.033c.953-.027,2.3-.051,3.9-.011,3.2.057,7.428.275,11.654.68,4.23.344,8.452.834,11.632,1.269,1.6.222,2.906.441,3.842.606l1.49.314s-.435-.348-1.233-.891A22.62,22.62,0,0,0,1172.564,987.471Z"
                        transform="translate(-1143.388 -984.614)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8569"
                      data-name="Group 8569"
                      transform="translate(868.099 697.863)"
                    >
                      <path
                        id="Path_23062"
                        data-name="Path 23062"
                        d="M1154.385,1066.075s-.451,2.12-.962,5.159a102.008,102.008,0,0,1-2.4,10.888c-1.088,3.862-2.547,7.651-3.648,10.565-1.117,2.9-1.758,4.954-1.758,4.954a29.811,29.811,0,0,0,3.375-4.1,35.478,35.478,0,0,0,2.8-4.679c.413-.912.911-1.831,1.253-2.833.388-.983.716-2.01,1.043-3.036.264-1.045.523-2.09.715-3.132a30.02,30.02,0,0,0,.415-3.077,32.325,32.325,0,0,0,.023-5.467A26.9,26.9,0,0,0,1154.385,1066.075Z"
                        transform="translate(-1145.621 -1066.075)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8570"
                      data-name="Group 8570"
                      transform="translate(859.933 710.823)"
                    >
                      <path
                        id="Path_23063"
                        data-name="Path 23063"
                        d="M1154.948,1096.925a25.453,25.453,0,0,0-4.272-2.606,35.48,35.48,0,0,0-5.337-2.068,33.163,33.163,0,0,0-10.578-1.274,19.862,19.862,0,0,0-4.8.751s1.91.461,4.647,1.073,6.325,1.491,9.849,2.511,7,2.175,9.6,3.2c1.31.509,2.37.942,3.16,1.284s1.236.513,1.236.513-.3-.387-.864-1.022A18.23,18.23,0,0,0,1154.948,1096.925Z"
                        transform="translate(-1129.959 -1090.932)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8571"
                      data-name="Group 8571"
                      transform="translate(635.23 784.881)"
                    >
                      <path
                        id="Path_23064"
                        data-name="Path 23064"
                        d="M712.973,1332.536c-.071-.254-.087-.394-.2-.747a59.651,59.651,0,0,0-2.047-5.675c-.44-.935-.878-1.871-1.31-2.793a28.631,28.631,0,0,0-1.507-2.655,12.709,12.709,0,0,0-4.066-3.88,15.911,15.911,0,0,0-3.466-1.608,14,14,0,0,0-1.384-.384l1.073.933c.676.587,1.623,1.428,2.635,2.479a15.945,15.945,0,0,1,2.781,3.857c.389.764.747,1.7,1.152,2.569l1.161,2.73,2.345,5.4c.055.09.159.407.235.6l.153.489a8.873,8.873,0,0,1,.237,1.153,20.029,20.029,0,0,1,.154,2.287,26.006,26.006,0,0,1-.445,4.987,13.746,13.746,0,0,0,2.669-7.36,11.5,11.5,0,0,0-.026-1.513A7.453,7.453,0,0,0,712.973,1332.536Z"
                        transform="translate(-698.989 -1314.795)"
                        fill="#e49d3c"
                      />
                    </g>
                    <g
                      id="Group_8572"
                      data-name="Group 8572"
                      transform="translate(641.151 782.726)"
                    >
                      <path
                        id="Path_23065"
                        data-name="Path 23065"
                        d="M719.028,1331.2a10,10,0,0,1-.885-2.042c-.582-1.669-1.315-3.4-2.037-5.129-.783-1.7-1.556-3.412-2.383-4.966a16.74,16.74,0,0,1-.978-2.046,9.346,9.346,0,0,1-.458-1.944,9.224,9.224,0,0,1,.245-3.161,11.427,11.427,0,0,1,.375-1.25,6.039,6.039,0,0,0-.939.967,7.34,7.34,0,0,0-1.5,3.358,7.826,7.826,0,0,0-.032,2.564,11.383,11.383,0,0,0,.755,2.708c.582,1.669,1.312,3.4,2.033,5.13.782,1.7,1.552,3.414,2.38,4.967a8.427,8.427,0,0,0,1.588,2.358,7.645,7.645,0,0,0,2.077,1.516,8.363,8.363,0,0,0,3.52.958,4.447,4.447,0,0,0,1.35-.128,10.317,10.317,0,0,1-3.832-2.337A8.988,8.988,0,0,1,719.028,1331.2Z"
                        transform="translate(-710.345 -1310.661)"
                        fill="#e49d3c"
                      />
                    </g>
                    <g
                      id="Group_8573"
                      data-name="Group 8573"
                      transform="translate(656.226 825.371)"
                    >
                      <path
                        id="Path_23066"
                        data-name="Path 23066"
                        d="M755.051,1404.753a41.592,41.592,0,0,0-2.963-4.784l-1.616-2.235c-.563-.787-.86-1.272-1.615-2.273a8.849,8.849,0,0,0-4.689-2.7,9.849,9.849,0,0,0-3.6-.245,5.728,5.728,0,0,0-1.313.3,14.632,14.632,0,0,1,4.237,1.673,9.468,9.468,0,0,1,3.113,2.684c.26.43.8,1.565,1.306,2.279l1.573,2.351c1.106,1.507,2.182,3,3.133,4.364a5.866,5.866,0,0,1,.955,1.8A14.353,14.353,0,0,1,753.9,1410a30.266,30.266,0,0,1,.013,4.633,11.537,11.537,0,0,0,1.827-4.518,9.442,9.442,0,0,0,.2-2.494A6.575,6.575,0,0,0,755.051,1404.753Z"
                        transform="translate(-739.258 -1392.453)"
                        fill="#e49d3c"
                      />
                    </g>
                    <g
                      id="Group_8574"
                      data-name="Group 8574"
                      transform="translate(662.977 820.327)"
                    >
                      <path
                        id="Path_23067"
                        data-name="Path 23067"
                        d="M767.219,1403.823a13.521,13.521,0,0,1-3.067-.994,10.128,10.128,0,0,1-1.74-1,2.977,2.977,0,0,1-.6-.562l-.172-.241s-.123-.166-.028-.053l-.077-.136-.331-.542c-.871-1.489-1.865-3.051-2.856-4.6l-2.99-4.445a4.6,4.6,0,0,1-.756-1.786,13.486,13.486,0,0,1-.19-2.026c0-1.328.067-2.507.093-3.334s.02-1.316.02-1.316-.253.412-.639,1.153a16.64,16.64,0,0,0-1.3,3.251,9.1,9.1,0,0,0-.369,2.462,5.989,5.989,0,0,0,.684,2.975,46.25,46.25,0,0,0,2.794,4.81c1.049,1.553,2.129,3.073,3.249,4.444l.416.516.108.125a1.326,1.326,0,0,0,.176.191l.245.234a5.294,5.294,0,0,0,1.368.891,8.566,8.566,0,0,0,2.411.7,9.312,9.312,0,0,0,3.58-.1,4.306,4.306,0,0,0,1.25-.483A5.865,5.865,0,0,1,767.219,1403.823Z"
                        transform="translate(-752.206 -1382.779)"
                        fill="#e49d3c"
                      />
                    </g>
                    <g
                      id="Group_8575"
                      data-name="Group 8575"
                      transform="translate(960.766 601.037)"
                    >
                      <path
                        id="Path_23068"
                        data-name="Path 23068"
                        d="M1326.424,962.19l-.219,6.027c-.127,3.584-.282,8.325-.568,13.034-.1,2.358-.3,4.7-.5,6.9-.212,2.2-.437,4.246-.708,6s-.515,3.229-.749,4.253c-.213,1.045-.334,1.642-.334,1.642s.349-.495.923-1.409a22.36,22.36,0,0,0,1.928-4.018,34.7,34.7,0,0,0,1.716-6.056,52.444,52.444,0,0,0,.9-7.128,57.884,57.884,0,0,0-.8-13.352A29.3,29.3,0,0,0,1326.424,962.19Z"
                        transform="translate(-1323.351 -962.19)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8576"
                      data-name="Group 8576"
                      transform="translate(948.535 617.97)"
                    >
                      <path
                        id="Path_23069"
                        data-name="Path 23069"
                        d="M1315.332,997.449a101.988,101.988,0,0,1-10.612-1.511c-.731-.128-1.367-.324-1.959-.458a13.358,13.358,0,0,1-1.516-.419l-1.353-.394s.361.356,1.051.952a7.83,7.83,0,0,0,1.318.973,13.334,13.334,0,0,0,1.843,1.069,24.182,24.182,0,0,0,4.97,1.868,38.816,38.816,0,0,0,5.942,1.089,48.37,48.37,0,0,0,6,.165,40.762,40.762,0,0,0,5.2-.5,27.313,27.313,0,0,0,4.972-1.2s-2.044-.328-5.026-.617Z"
                        transform="translate(-1299.892 -994.667)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8577"
                      data-name="Group 8577"
                      transform="translate(951.144 661.801)"
                    >
                      <path
                        id="Path_23070"
                        data-name="Path 23070"
                        d="M1312.277,1078.733s-.344,2.382-.861,5.954c-.248,1.763-.537,3.82-.847,6.023s-.644,4.525-1.047,6.84a109.59,109.59,0,0,1-2.686,12.587c-.5,1.684-.946,3.11-1.349,4.071l-.59,1.564s.422-.43,1.135-1.239a19.725,19.725,0,0,0,2.494-3.692,31.062,31.062,0,0,0,2.456-5.8,49.726,49.726,0,0,0,1.685-6.977,57.547,57.547,0,0,0,.571-13.326A31.129,31.129,0,0,0,1312.277,1078.733Z"
                        transform="translate(-1304.897 -1078.733)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8578"
                      data-name="Group 8578"
                      transform="translate(936.639 676.421)"
                    >
                      <path
                        id="Path_23071"
                        data-name="Path 23071"
                        d="M1312.9,1115.971a26.2,26.2,0,0,0-3.7-2.57,50.261,50.261,0,0,0-12.56-5.031,54.374,54.374,0,0,0-7.124-1.319,37.534,37.534,0,0,0-6.338-.225,23.744,23.744,0,0,0-4.454.565c-1.058.256-1.644.431-1.644.431l1.678.2c1.056.123,2.549.315,4.315.629,3.533.6,8.176,1.583,12.774,2.8,4.614,1.154,9.184,2.5,12.6,3.606,1.715.557,3.111,1.065,4.1,1.436l1.566.649S1313.688,1116.7,1312.9,1115.971Z"
                        transform="translate(-1277.076 -1106.773)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8579"
                      data-name="Group 8579"
                      transform="translate(927.177 726.761)"
                    >
                      <path
                        id="Path_23072"
                        data-name="Path 23072"
                        d="M1274.7,1205c-.328,1.056-.8,2.565-1.358,4.375a103.866,103.866,0,0,1-4.761,12.724,125.437,125.437,0,0,1-6.476,11.979c-1.944,3.23-3.178,5.5-3.178,5.5a40.638,40.638,0,0,0,4.646-4.411,46.55,46.55,0,0,0,4.12-5.14c.653-1.017,1.4-2.032,1.992-3.165.64-1.1,1.215-2.271,1.791-3.435.51-1.2,1.013-2.394,1.437-3.6.462-1.192.756-2.42,1.085-3.586a42.205,42.205,0,0,0,1.13-6.506,36.332,36.332,0,0,0,.128-6.412S1275.055,1203.933,1274.7,1205Z"
                        transform="translate(-1258.929 -1203.324)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8580"
                      data-name="Group 8580"
                      transform="translate(920.511 737.335)"
                    >
                      <path
                        id="Path_23073"
                        data-name="Path 23073"
                        d="M1274.944,1234.928a32.823,32.823,0,0,0-4.644-3.854,45.605,45.605,0,0,0-5.979-3.467,48.782,48.782,0,0,0-6.449-2.448,37.765,37.765,0,0,0-5.877-1.26,26.334,26.334,0,0,0-5.85-.227l5.405,2c3.2,1.191,7.361,2.893,11.408,4.812a106.1,106.1,0,0,1,10.851,5.866c1.449.9,2.612,1.672,3.463,2.26l1.333.9-.883-1.345A23.626,23.626,0,0,0,1274.944,1234.928Z"
                        transform="translate(-1246.145 -1223.604)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8581"
                      data-name="Group 8581"
                      transform="translate(909.558 784.881)"
                    >
                      <path
                        id="Path_23074"
                        data-name="Path 23074"
                        d="M1234.451,1316.787a12.709,12.709,0,0,0-4.066,3.88,28.39,28.39,0,0,0-1.506,2.655l-1.311,2.793a59.666,59.666,0,0,0-2.047,5.675c-.117.353-.134.493-.2.747a7.568,7.568,0,0,0-.139.866,11.621,11.621,0,0,0-.027,1.513,13.747,13.747,0,0,0,2.67,7.36,26.038,26.038,0,0,1-.445-4.987,20.029,20.029,0,0,1,.154-2.287,8.823,8.823,0,0,1,.237-1.153l.152-.489c.076-.189.18-.506.235-.6l2.345-5.4,1.161-2.73c.4-.866.762-1.805,1.151-2.569a15.946,15.946,0,0,1,2.781-3.857c1.012-1.051,1.959-1.893,2.635-2.479l1.073-.933a14.047,14.047,0,0,0-1.384.384A15.905,15.905,0,0,0,1234.451,1316.787Z"
                        transform="translate(-1225.137 -1314.795)"
                        fill="#e49d3c"
                      />
                    </g>
                    <g
                      id="Group_8582"
                      data-name="Group 8582"
                      transform="translate(904.007 782.726)"
                    >
                      <path
                        id="Path_23075"
                        data-name="Path 23075"
                        d="M1226.66,1311.628a6.009,6.009,0,0,0-.939-.967,11.437,11.437,0,0,1,.375,1.25,9.209,9.209,0,0,1,.245,3.161,9.346,9.346,0,0,1-.458,1.944,16.748,16.748,0,0,1-.978,2.046c-.827,1.554-1.6,3.262-2.383,4.966-.722,1.733-1.455,3.46-2.037,5.129a10,10,0,0,1-.885,2.042,8.966,8.966,0,0,1-1.278,1.521,10.317,10.317,0,0,1-3.832,2.337,4.446,4.446,0,0,0,1.35.128,8.36,8.36,0,0,0,3.52-.958,7.649,7.649,0,0,0,2.077-1.516,8.432,8.432,0,0,0,1.588-2.358c.827-1.553,1.6-3.263,2.38-4.967.721-1.733,1.451-3.462,2.033-5.13a11.386,11.386,0,0,0,.755-2.708,7.841,7.841,0,0,0-.032-2.564A7.339,7.339,0,0,0,1226.66,1311.628Z"
                        transform="translate(-1214.49 -1310.661)"
                        fill="#e49d3c"
                      />
                    </g>
                    <g
                      id="Group_8583"
                      data-name="Group 8583"
                      transform="translate(886.024 825.371)"
                    >
                      <path
                        id="Path_23076"
                        data-name="Path 23076"
                        d="M1191.792,1392.765a8.849,8.849,0,0,0-4.689,2.7c-.755,1-1.052,1.486-1.615,2.273l-1.617,2.235a41.575,41.575,0,0,0-2.963,4.784,6.581,6.581,0,0,0-.891,2.865,9.416,9.416,0,0,0,.2,2.494,11.536,11.536,0,0,0,1.827,4.518,30.178,30.178,0,0,1,.013-4.633,14.292,14.292,0,0,1,.328-2.029,5.871,5.871,0,0,1,.955-1.8c.952-1.364,2.027-2.857,3.134-4.364l1.572-2.351c.51-.714,1.045-1.849,1.306-2.279a9.459,9.459,0,0,1,3.113-2.684,14.639,14.639,0,0,1,4.237-1.673,5.706,5.706,0,0,0-1.313-.3A9.85,9.85,0,0,0,1191.792,1392.765Z"
                        transform="translate(-1180 -1392.453)"
                        fill="#e49d3c"
                      />
                    </g>
                    <g
                      id="Group_8584"
                      data-name="Group 8584"
                      transform="translate(879.688 820.327)"
                    >
                      <path
                        id="Path_23077"
                        data-name="Path 23077"
                        d="M1182.458,1383.932c-.386-.741-.639-1.153-.639-1.153s.006.479.019,1.316.1,2.006.093,3.334a13.494,13.494,0,0,1-.19,2.026,4.6,4.6,0,0,1-.757,1.786l-2.99,4.445c-.99,1.554-1.985,3.116-2.856,4.6l-.331.542-.077.136c.095-.113-.029.053-.029.053l-.172.241a2.982,2.982,0,0,1-.6.562,10.126,10.126,0,0,1-1.739,1,13.531,13.531,0,0,1-3.067.994,5.868,5.868,0,0,1-1.274.126,4.314,4.314,0,0,0,1.25.483,9.311,9.311,0,0,0,3.58.1,8.569,8.569,0,0,0,2.411-.7,5.294,5.294,0,0,0,1.368-.891l.244-.234a1.262,1.262,0,0,0,.176-.191l.109-.125.416-.516c1.12-1.371,2.2-2.891,3.249-4.444a46.349,46.349,0,0,0,2.794-4.81,6,6,0,0,0,.683-2.975,9.1,9.1,0,0,0-.369-2.462A16.692,16.692,0,0,0,1182.458,1383.932Z"
                        transform="translate(-1167.848 -1382.779)"
                        fill="#e49d3c"
                      />
                    </g>
                  </g>
                  <text
                    id="_28"
                    data-name={28}
                    transform="translate(1130.899 511.585)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            28\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_27"
                    data-name={27}
                    transform="translate(1119.664 432.306)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            27\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_26"
                    data-name={26}
                    transform="translate(1104.781 363.25)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            26\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_25"
                    data-name={25}
                    transform="translate(1083.74 309.006)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            25\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_24"
                    data-name={24}
                    transform="translate(1057.74 261.852)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            24\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_23"
                    data-name={23}
                    transform="translate(1020.13 226.44)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            23\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_22"
                    data-name={22}
                    transform="translate(976.13 194.875)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            22\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_21"
                    data-name={21}
                    transform="translate(924 181.375)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            21\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_18"
                    data-name={18}
                    transform="translate(651.766 505.97)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            18\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_55"
                    data-name={55}
                    transform="translate(824.065 490.97)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            55\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_85"
                    data-name={85}
                    transform="translate(828.065 658.47)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            85\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_84"
                    data-name={84}
                    transform="translate(834.565 703.47)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            84\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_83"
                    data-name={83}
                    transform="translate(845.065 734.47)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            83\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_82"
                    data-name={82}
                    transform="translate(862.065 752.47)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            82\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_81"
                    data-name={81}
                    transform="translate(885.069 763.47)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            81\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_71"
                    data-name={71}
                    transform="translate(908.073 763.47)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            71\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_72"
                    data-name={72}
                    transform="translate(933.076 752.47)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            72\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_73"
                    data-name={73}
                    transform="translate(947.076 734.47)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            73\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_74"
                    data-name={74}
                    transform="translate(953.076 703.47)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            74\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_75"
                    data-name={75}
                    transform="translate(959.076 658.47)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            75\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_54"
                    data-name={54}
                    transform="translate(828.065 443.67)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            54\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_53"
                    data-name={53}
                    transform="translate(834.565 413.17)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            53\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_52"
                    data-name={52}
                    transform="translate(849.065 391.17)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            52\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_51"
                    data-name={51}
                    transform="translate(873.065 378.17)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            51\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_61"
                    data-name={61}
                    transform="translate(911.065 377.17)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            61\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_62"
                    data-name={62}
                    transform="translate(935.065 385.25)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            62\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_63"
                    data-name={63}
                    transform="translate(953.065 407.25)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            63\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_64"
                    data-name={64}
                    transform="translate(959.076 445.47)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            64\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_65"
                    data-name={65}
                    transform="translate(962.576 490.47)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            65\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_17"
                    data-name={17}
                    transform="translate(663.001 438.17)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            17\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_16"
                    data-name={16}
                    transform="translate(672.35 363.25)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            16\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_14"
                    data-name={14}
                    transform="translate(720.277 261.852)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            14\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_13"
                    data-name={13}
                    transform="translate(761.342 221.875)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            13\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_12"
                    data-name={12}
                    transform="translate(804.131 194.875)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            12\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_11"
                    data-name={11}
                    transform="translate(864.065 181.375)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            11\n          "}
                    </tspan>
                  </text>
                  <text
                    id="_15"
                    data-name={15}
                    transform="translate(707.277 309.006)"
                    fill="#070606"
                    fontSize={16}
                    fontFamily="Lato-Bold, Lato"
                    fontWeight={500}
                    style={{
                      isolation: "isolate",
                    }}
                  >
                    <tspan x={0} y={0}>
                      {"\n            15\n          "}
                    </tspan>
                  </text>
                  <g
                    id="Group_8588"
                    data-name="Group 8588"
                    transform="translate(-56.59 -720.256)"
                  >
                    <text
                      id="_31"
                      data-name={31}
                      transform="translate(968.367 1644.844)"
                      fontSize={21}
                      fontFamily="Lato-Bold, Lato"
                      fontWeight={500}
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <tspan x={0} y={0}>
                        {"\n              31\n            "}
                      </tspan>
                    </text>
                    <text
                      id="_42"
                      data-name={42}
                      transform="translate(878.251 1632.344)"
                      fontSize={21}
                      fontFamily="Lato-Bold, Lato"
                      fontWeight={500}
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <tspan x={0} y={0}>
                        {"\n              42\n            "}
                      </tspan>
                    </text>
                    <text
                      id="_32"
                      data-name={32}
                      transform="translate(1007.591 1632.344)"
                      fontSize={21}
                      fontFamily="Lato-Bold, Lato"
                      fontWeight={500}
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <tspan x={0} y={0}>
                        {"\n              32\n            "}
                      </tspan>
                    </text>
                    <text
                      id="_33"
                      data-name={33}
                      transform="translate(1052.649 1618.44)"
                      fontSize={21}
                      fontFamily="Lato-Bold, Lato"
                      fontWeight={500}
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <tspan x={0} y={0}>
                        {"\n              33\n            "}
                      </tspan>
                    </text>
                    <text
                      id="_34"
                      data-name={34}
                      transform="translate(1097.492 1576.909)"
                      fontSize={21}
                      fontFamily="Lato-Bold, Lato"
                      fontWeight={500}
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <tspan x={0} y={0}>
                        {"\n              34\n            "}
                      </tspan>
                    </text>
                    <text
                      id="_35"
                      data-name={35}
                      transform="translate(1121.492 1534.909)"
                      fontSize={21}
                      fontFamily="Lato-Bold, Lato"
                      fontWeight={500}
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <tspan x={0} y={0}>
                        {"\n              35\n            "}
                      </tspan>
                    </text>
                    <text
                      id="_36"
                      data-name={36}
                      transform="translate(1156.925 1471.416)"
                      fontSize={21}
                      fontFamily="Lato-Bold, Lato"
                      fontWeight={500}
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <tspan x={0} y={0}>
                        {"\n              36\n            "}
                      </tspan>
                    </text>
                    <text
                      id="_37"
                      data-name={37}
                      transform="translate(1180.925 1400.789)"
                      fontSize={21}
                      fontFamily="Lato-Bold, Lato"
                      fontWeight={500}
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <tspan x={0} y={0}>
                        {"\n              37\n            "}
                      </tspan>
                    </text>
                    <text
                      id="_38"
                      data-name={38}
                      transform="translate(1180.925 1335.756)"
                      fontSize={21}
                      fontFamily="Lato-Bold, Lato"
                      fontWeight={500}
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <tspan x={0} y={0}>
                        {"\n              38\n            "}
                      </tspan>
                    </text>
                    <text
                      id="_41"
                      data-name={41}
                      transform="translate(923.309 1643.44)"
                      fontSize={21}
                      fontFamily="Lato-Bold, Lato"
                      fontWeight={500}
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <tspan x={0} y={0}>
                        {"\n              41\n            "}
                      </tspan>
                    </text>
                    <text
                      id="_43"
                      data-name={43}
                      transform="translate(833.192 1614.409)"
                      fontSize={21}
                      fontFamily="Lato-Bold, Lato"
                      fontWeight={500}
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <tspan x={0} y={0}>
                        {"\n              43\n            "}
                      </tspan>
                    </text>
                    <text
                      id="_44"
                      data-name={44}
                      transform="translate(792.948 1571.409)"
                      fontSize={21}
                      fontFamily="Lato-Bold, Lato"
                      fontWeight={500}
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <tspan x={0} y={0}>
                        {"\n              44\n            "}
                      </tspan>
                    </text>
                    <text
                      id="_45"
                      data-name={45}
                      transform="translate(768.948 1534.909)"
                      fontSize={21}
                      fontFamily="Lato-Bold, Lato"
                      fontWeight={500}
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <tspan x={0} y={0}>
                        {"\n              45\n            "}
                      </tspan>
                    </text>
                    <text
                      id="_46"
                      data-name={46}
                      transform="translate(739.078 1483.916)"
                      fontSize={21}
                      fontFamily="Lato-Bold, Lato"
                      fontWeight={500}
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <tspan x={0} y={0}>
                        {"\n              46\n            "}
                      </tspan>
                    </text>
                    <text
                      id="_47"
                      data-name={47}
                      transform="translate(725.714 1418.789)"
                      fontSize={21}
                      fontFamily="Lato-Bold, Lato"
                      fontWeight={500}
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <tspan x={0} y={0}>
                        {"\n              47\n            "}
                      </tspan>
                    </text>
                    <text
                      id="_48"
                      data-name={48}
                      transform="translate(707.714 1348.256)"
                      fontSize={21}
                      fontFamily="Lato-Bold, Lato"
                      fontWeight={500}
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <tspan x={0} y={0}>
                        {"\n              48\n            "}
                      </tspan>
                    </text>
                  </g>
                </g>
                <g
                  id="Group_8608"
                  data-name="Group 8608"
                  transform="translate(180.596 831.064)"
                >
                  <g
                    id="Group_8592"
                    data-name="Group 8592"
                    transform="translate(85.259 3.582)"
                  >
                    <g
                      id="Group_8590"
                      data-name="Group 8590"
                      transform="translate(0.061 4.666)"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_23078"
                        data-name="Path 23078"
                        d="M748.855,1719.6c.115,8.48,9.184,24.333,19.149,23.923,7.363-.3,17.348-15.4,17.127-23.278S748.741,1711.119,748.855,1719.6Z"
                        transform="translate(-748.855 -1713.767)"
                        fill="#94e7cb"
                      />
                    </g>
                    <g
                      id="Group_8591"
                      data-name="Group 8591"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_23079"
                        data-name="Path 23079"
                        d="M767.1,1701.249c-10.787.141-18.918,4.237-18.383,9.993.408,4.379,5.981,2.056,9.315,2.894s4.8,4.668,8.854,4.8c3.03.1,5.728-1.783,9.029-3.562s8.615.31,8.811-4.781C784.864,1707.009,777.886,1701.108,767.1,1701.249Z"
                        transform="translate(-748.692 -1701.246)"
                        fill="#46bc94"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_8595"
                    data-name="Group 8595"
                    transform="translate(0 3.246)"
                  >
                    <g
                      id="Group_8593"
                      data-name="Group 8593"
                      transform="translate(0.337 1.479)"
                    >
                      <path
                        id="Path_23080"
                        data-name="Path 23080"
                        d="M331.266,1711.094c.312,4.264,5.182,27.13,18.124,26.839s16.538-22.466,16.559-30.121S330.957,1706.833,331.266,1711.094Z"
                        transform="translate(-331.264 -1704.315)"
                        fill="#8ae6ab"
                      />
                    </g>
                    <g
                      id="Group_8594"
                      data-name="Group 8594"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_23081"
                        data-name="Path 23081"
                        d="M349,1700.806c-7.686.634-19.346-.315-18.6,7.546.361,3.8,9.854,2.521,18.016,2.028s16.734.588,16.941-4.4C365.638,1699.14,356.684,1700.172,349,1700.806Z"
                        transform="translate(-330.36 -1700.346)"
                        fill="#67c78a"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_8599"
                    data-name="Group 8599"
                    transform="translate(304.236 0)"
                  >
                    <g
                      id="Group_8596"
                      data-name="Group 8596"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_23082"
                        data-name="Path 23082"
                        d="M1629.061,1693.548c-5-4-10.172-.5-15.624-.351s-13.885-2.516-17.562,3.665c-4.373,7.351.393,12.825.481,17.363s-3.546,12.3,1.6,16.634,11.928,1.476,16.61,1.109,13.266,1.287,17.408-4.594.78-11.335-.145-16.3S1634.059,1697.551,1629.061,1693.548Z"
                        transform="translate(-1594.031 -1691.637)"
                        fill="#fed3b6"
                      />
                    </g>
                    <g
                      id="Group_8597"
                      data-name="Group 8597"
                      transform="translate(18.045 6.513)"
                    >
                      <path
                        id="Path_23083"
                        data-name="Path 23083"
                        d="M1645.794,1733c-.2-1.308-.37-2.842-.53-4.483-.144-1.642-.3-3.4-.371-5.158-.213-3.52-.329-7.064-.424-9.743-.1-2.7-.164-4.505-.164-4.505a21.894,21.894,0,0,0-1.195,4.4,43.244,43.244,0,0,0-.595,9.98,39.264,39.264,0,0,0,.672,5.328,25.946,25.946,0,0,0,1.282,4.527,16.744,16.744,0,0,0,1.441,3c.429.683.691,1.053.691,1.053s-.091-.446-.25-1.228C1646.178,1735.416,1645.989,1734.312,1645.794,1733Z"
                        transform="translate(-1642.451 -1709.113)"
                        fill="#e18446"
                      />
                    </g>
                    <g
                      id="Group_8598"
                      data-name="Group 8598"
                      transform="translate(7.953 19.171)"
                    >
                      <path
                        id="Path_23084"
                        data-name="Path 23084"
                        d="M1636.614,1743.685c-.443.1-.919.247-1.465.342a76.2,76.2,0,0,1-7.932,1.129l-8.089.761c-2.229.216-3.757.461-3.757.461a20.406,20.406,0,0,0,3.717.9,30.532,30.532,0,0,0,3.884.371,36.183,36.183,0,0,0,4.482-.123,29.091,29.091,0,0,0,4.442-.814,18.1,18.1,0,0,0,3.715-1.4,10.049,10.049,0,0,0,1.378-.8,5.856,5.856,0,0,0,.985-.728c.515-.445.785-.711.785-.711l-1.011.295A9.966,9.966,0,0,1,1636.614,1743.685Z"
                        transform="translate(-1615.371 -1743.077)"
                        fill="#e18446"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_8603"
                    data-name="Group 8603"
                    transform="translate(194.716 3.248)"
                  >
                    <g
                      id="Group_8600"
                      data-name="Group 8600"
                      style={{
                        isolation: "isolate",
                      }}
                    >
                      <path
                        id="Path_23085"
                        data-name="Path 23085"
                        d="M1187.375,1700.843c-6.324-.041-10.3-1.974-14.289,2.125-5.577,5.736-6.027,23.712-.186,29.767,4.251,4.407,9.872,2.176,16.282,1.952,6.144-.215,9.005-.393,12.626-4.241,4.552-4.839,4.422-22.253-.528-26.975C1197.1,1699.486,1194.135,1700.885,1187.375,1700.843Z"
                        transform="translate(-1168.707 -1700.352)"
                        fill="#ffe394"
                      />
                    </g>
                    <g
                      id="Group_8601"
                      data-name="Group 8601"
                      transform="translate(14.318 4.875)"
                    >
                      <path
                        id="Path_23086"
                        data-name="Path 23086"
                        d="M1213.579,1722.831c-.058-.9-.055-1.428-.16-2.591a8.241,8.241,0,0,0-2.383-4.437,9.174,9.174,0,0,0-2.724-1.961,5.316,5.316,0,0,0-1.186-.408,13.629,13.629,0,0,1,2.529,3.4,8.809,8.809,0,0,1,1.143,3.652c-.005.468-.139,1.628-.087,2.444.029.868.058,1.75.088,2.632.134,1.736.252,3.444.333,4.99a5.446,5.446,0,0,1-.13,1.893,13.255,13.255,0,0,1-.737,1.766,28.175,28.175,0,0,1-2.266,3.67,10.743,10.743,0,0,0,3.665-2.676,8.775,8.775,0,0,0,1.384-1.874,6.128,6.128,0,0,0,.7-2.7,38.8,38.8,0,0,0,.008-5.239C1213.7,1724.534,1213.638,1723.676,1213.579,1722.831Z"
                        transform="translate(-1207.126 -1713.433)"
                        fill="#e49d3c"
                      />
                    </g>
                    <g
                      id="Group_8602"
                      data-name="Group 8602"
                      transform="translate(17.858 5.052)"
                    >
                      <path
                        id="Path_23087"
                        data-name="Path 23087"
                        d="M1220.676,1734.5a9.391,9.391,0,0,1-.882-1.649,2.757,2.757,0,0,1-.2-.741l-.017-.275s-.016-.192,0-.056l.006-.145.005-.591c.043-1.6.024-3.33,0-5.045-.061-1.7-.122-3.394-.18-4.985a4.286,4.286,0,0,1,.28-1.785,12.559,12.559,0,0,1,.845-1.7c.65-1.052,1.285-1.949,1.712-2.59l.661-1.032s-.4.2-1.072.6a15.469,15.469,0,0,0-2.628,1.93,8.51,8.51,0,0,0-1.5,1.765,5.584,5.584,0,0,0-.921,2.689,43.181,43.181,0,0,0-.155,5.176c.067,1.744.174,3.476.386,5.111l.075.613.025.152a1.221,1.221,0,0,0,.045.238l.079.3a4.925,4.925,0,0,0,.644,1.378,8,8,0,0,0,1.562,1.74,8.68,8.68,0,0,0,2.881,1.68,4.014,4.014,0,0,0,1.226.233,5.48,5.48,0,0,1-.945-.726A12.636,12.636,0,0,1,1220.676,1734.5Z"
                        transform="translate(-1216.626 -1713.908)"
                        fill="#e49d3c"
                      />
                    </g>
                  </g>
                </g>
                <g
                  id="Layer_6"
                  data-name="Layer 6"
                  transform="translate(-540.048 -762.973)"
                >
                  <path
                    id="Path_23120"
                    data-name="Path 23120"
                    d="M0,0H575.915"
                    transform="translate(617.12 1154.125)"
                    fill="none"
                    stroke="#dbdbdb"
                    strokeLinecap="round"
                    strokeWidth={5}
                  />
                  <path
                    id="Path_23119"
                    data-name="Path 23119"
                    d="M0,0V57.973"
                    transform="translate(902.279 1126.093)"
                    fill="none"
                    stroke="#dbdbdb"
                    strokeLinecap="round"
                    strokeWidth={4}
                  />
                  <path
                    id="Path_23115"
                    data-name="Path 23115"
                    d="M1206.117,1132.915l9.191-13.614,9.191,13.614"
                    transform="translate(-313.029 4.883)"
                    fill="none"
                    stroke="#dbdbdb"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={5}
                  />
                  <path
                    id="Path_23116"
                    data-name="Path 23116"
                    d="M1224.5,1257.045l-9.191,13.614-9.191-13.614"
                    transform="translate(-313.029 -86.593)"
                    fill="none"
                    stroke="#dbdbdb"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={4}
                  />
                  <path
                    id="Path_23117"
                    data-name="Path 23117"
                    d="M1804.683,1184.786l15.191,8.237-15.191,8.237"
                    transform="translate(-619.244 -38.898)"
                    fill="none"
                    stroke="#dbdbdb"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={5}
                  />
                  <path
                    id="Path_23118"
                    data-name="Path 23118"
                    d="M629.512,1201.26l-15.2-8.237,15.2-8.237"
                    transform="translate(0 -37.839)"
                    fill="none"
                    stroke="#dbdbdb"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={5}
                  />
                </g>
                <text
                  id="lEFT"
                  transform="translate(682.269 397.606)"
                  fill="#0cb87e"
                  fontSize={14}
                  fontFamily="Lato-Black, Lato"
                  fontWeight={800}
                  style={{
                    isolation: "isolate",
                  }}
                >
                  <tspan x={0} y={0}>
                    {"\n      LEFT \n        "}
                  </tspan>
                </text>
                <text
                  id="Molars"
                  transform="translate(483.728 895.077)"
                  fill="#070606"
                  fontSize={13}
                  fontFamily="Lato-Regular, Lato"
                  style={{
                    isolation: "isolate",
                  }}
                >
                  <tspan x={0} y={0}>
                    {"\n          Molars\n        "}
                  </tspan>
                </text>
                <text
                  id="Premolars"
                  transform="translate(369.657 895.077)"
                  fill="#070606"
                  fontSize={13}
                  fontFamily="Lato-Regular, Lato"
                  style={{
                    isolation: "isolate",
                  }}
                >
                  <tspan x={0} y={0}>
                    {"\n          Premolars\n        "}
                  </tspan>
                </text>
                <text
                  id="Canine"
                  transform="translate(271.101 895.077)"
                  fill="#070606"
                  fontSize={13}
                  fontFamily="Lato-Regular, Lato"
                  style={{
                    isolation: "isolate",
                  }}
                >
                  <tspan x={0} y={0}>
                    {"\n          Canine\n        "}
                  </tspan>
                </text>
                <text
                  id="Incisors"
                  transform="translate(182.582 896.902)"
                  fill="#070606"
                  fontSize={13}
                  fontFamily="Lato-Regular, Lato"
                  style={{
                    isolation: "isolate",
                  }}
                >
                  <tspan x={0} y={0}>
                    {"\n          Incisors\n        "}
                  </tspan>
                </text>
                <text
                  id="UPPER_MAxillary_"
                  data-name="UPPER (MAxillary)"
                  transform="translate(352.696 324.417)"
                  fill="#ef8f00"
                  fontSize={14}
                  fontFamily="Lato-Black, Lato"
                  fontWeight={800}
                  style={{
                    isolation: "isolate",
                  }}
                >
                  <tspan x={-22.624} y={0}>
                    {"\n          UPPER\n        "}
                  </tspan>
                  <tspan x={-44.975} y={17}>
                    {"\n          (MAXILLARY)\n        "}
                  </tspan>
                </text>
                <text
                  id="Lower_Mandibular_"
                  data-name="Lower (Mandibular)"
                  transform="translate(356.627 442.625)"
                  fill="#ef8f00"
                  fontSize={14}
                  fontFamily="Lato-Black, Lato"
                  fontWeight={800}
                  style={{
                    isolation: "isolate",
                  }}
                >
                  <tspan x={-25.06} y={0}>
                    {"\n          LOWER\n        "}
                  </tspan>
                  <tspan x={-51.779} y={17}>
                    {"\n          (MANDIBULAR)\n        "}
                  </tspan>
                </text>
                <text
                  id="rIGHT"
                  transform="translate(0 397.606)"
                  fill="#0cb87e"
                  fontSize={14}
                  fontFamily="Lato-Black, Lato"
                  fontWeight={800}
                  style={{
                    isolation: "isolate",
                  }}
                >
                  <tspan x={0} y={0}>
                    {"\n          RIGHT\n        "}
                  </tspan>
                </text>
              </svg>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};

export default TeethModalSelect;
